<template>
  <div class="app-main-inner section tab-charges" style="min-width:1000px">
    <cargo-up-down-resize
      :show-down="showDown"
      :show-up="showUp"
      :up-style="{display: 'flex', flexDirection: 'column', paddingBottom: showDown ? '5px' : ''}"
      :down-style="{display: 'flex', flexDirection: 'column', paddingTop: showUp ? '5px' : ''}"
      style="height: 100%"
    >
      <!--      应收-->
      <template slot="up">
        <div v-if="isBpm">
          <span style="">{{ $t('SeaExport.receivable') }}</span>
        </div>
        <div v-if="!isBpm" class="operations">
          <div class="triggers" @dblclick.self="tabSelling.visible=!tabSelling.visible">

            <div>
              <span style="">{{ $t('SeaExport.receivable') }}</span>
              <charge-currency-total-group
                v-if="reCalc"
                ref="arTotalGroup"
                no="arTotalGroup"
                :amount-to-currency="localCurrency"
                :data-provider="arTotalGroup.dataProvider"
                :data-field="config._isCalculateExcludingAmount ? 'amount' : 'excludingTaxAmount'"
                rate-field="exchangeRate"
                :is-gross-profit="true"
                :show-controlled-profit="privilege.showControlledProfit"
                :show-cost-controlled="privilege.isCostControlled"
                type="ar"
                source="chargeDetailAr"
                :auxiliary-map="apAuxiliaryDataMap"
              />
              <span v-show="showEstimate">
                <span>(</span>
                <span>{{ $t('FinanceManage.charge_estimate') }}</span>
                <!--应收预估 job.estimateAccountsReceivable-->
                <span style="text-decoration: underline;" @click="editEstimateHandler">{{ estimateAccountsReceivable }}</span>
                <span>)</span>
              </span>
            </div>
            <div v-show="job.priceNo&&job.priceNo.length">
              <span v-show="job.priceNo&&job.priceNo.length">{{ $t('FinanceManage.charge_sp1') }}</span>
              <el-tooltip placement="top" :content="$t('FinanceManage.charge_sp2')">
                <span style="text-decoration: underline;cursor: pointer" @click="tabChargesHP.onPriceNoClick(job.priceNo,$event)" @dblclick="tabChargesHP.onPriceNoDoubleClick()">
                  {{ job.priceNo }}
                </span>
              </el-tooltip>
            </div>
            <!--根据服务项目新增费用 -->
            <cargo-button-group-slider no="top" align="right" style="flex:1; border: none">
              <div>
                <el-button
                  v-if="!isAdjust && config.isInputChargeBaseOnService"
                  id="serviceBtn"
                  type="primary"
                  :disabled="!(editing) || !settleBranchEnable"
                  @click="tabChargesHP.addServiceTypChargeEvent()"
                >{{ $t('FinanceManage.charge_sp3') }}
                </el-button>
                <!--抄录费用-->
                <el-button
                  v-show="viewSource!=='salesDetail'"
                  v-if="job && job.jobState === 0 && privilege.copyCharge"
                  id="btnCpoyCharge"
                  type="primary"
                  :disabled="!editing || (lockArWithProvision && lockApWithProvision) || !settleBranchEnable"
                  @click="tabChargesHP.cpoyChargeHandler()"
                >{{ $t('FinanceManage.charge_copyCharge') }}
                </el-button>
                <!--同步云平台-->
                <el-button
                  v-if="job && config.toExoSystemYGSH"
                  id="btnSynchronizationLtsChargeAr"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.synchronizationLtsCharge(true)"
                >{{ $t('CargoMsg.Cargo_SynchronousCloudPlatform') }}
                </el-button>
                <!--销售查询 抄录费用-->
                <el-button
                  v-if="viewSource==='salesDetail' && job && job.jobState === 0 && privilege.copyCharge"
                  id="btnCpoyChargeSales"
                  type="primary"
                  :disabled="(lockArWithProvision && lockApWithProvision) || !settleBranchEnable"
                  @click="tabChargesHP.cpoyChargeHandler()"
                >{{ $t('FinanceManage.charge_copyCharge') }}
                </el-button>
                <!--更新汇率-->
                <el-button
                  v-if="job && job.jobState === 0"
                  id="btnRefreshRate"
                  type="primary"
                  :disabled="editing || lockArWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.refreshRateHandler()"
                >{{ $t('FinanceManage.charge_sp4') }}
                </el-button>
                <!--抄录小票费用-->
                <el-button
                  v-if="config.copySlaveCostToMasterCharge && !isAdjust && job.masterFlag && editing"
                  type="primary"
                  :disabled="!settleBranchEnable"
                  @click="tabChargesHP.copySlaveCostHandler()"
                >
                  {{ $t('FinanceManage.charge_sp5') }}
                </el-button>
                <!--    CARGO-2427:费用页签加 “邀请确认费用”按钮 by Deep Lau 2016/03/22    -->
                <!--邀请确认费用-->
                <el-button
                  v-if="privilege.isInviteChargeConfirm && showInviteChargeConfirm"
                  id="btnInviteToConfirmCharge"
                  type="primary"
                  :disabled="!(!editing) || !settleBranchEnable"
                  @click="tabChargesHP.confirmInviteCharge()"
                >{{ $t('FinanceManage.charge_inviteToConfirmTheCharges') }}
                </el-button>
                <!--新增费用-->
                <el-button
                  v-if="!isAdjust && privilege.isPayAddChargeRole && viewSource!=='salesDetail'"
                  id="btnAdd1"
                  type="primary"
                  :disabled="!(editing) || lockArWithProvision || !settleBranchEnable"
                  @click="addCostEventFlag=true"
                >{{ $t('FinanceManage.charge_add') }}
                </el-button>
                <!--复制费用-->
                <el-button
                  v-if="!isAdjust && privilege.isPayAddChargeRole && viewSource!=='salesDetail'"
                  id="btnCopy1"
                  type="primary"
                  :disabled="!(editing) || lockArWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.copyCharge(true)"
                >{{ $t('FinanceManage.charge_copy') }}
                </el-button>
                <!--修改结算对象-->
                <el-button
                  v-if="!isAdjust && viewSource!=='salesDetail' && showArChargeAuditButton"
                  id="btnChangeSettlementAr"
                  type="primary"
                  :disabled="!(editing) || lockArWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.changeAccountHandler(true)"
                >{{ $t('CargoMsg.Cargo_ChangeSettlement') }}
                </el-button>
                <!-- 新增特殊费用 -->
                <!-- 海创定制的特殊费用中，仅需要个性化参数和权限控制 -->
                <el-button
                  v-if="(isAllowedEdit && !isAdjust && privilege.addSpecialCharge && viewSource!=='salesDetail' && !job.fba) || (config.isSpecialExpenseEntryFunction && privilege.addSpecialCharge)"
                  id="addCostSpecialOCButton"
                  type="primary"
                  :disabled="!(btn.addCostSpecialOSButton.enabled) || !settleBranchEnable"
                  @click="tabChargesHP.addCostSpecial('add',true)"
                >{{ $t('FinanceManage.charge_newSpecial') }}
                </el-button>
                <!-- 编辑特殊费用 -->
                <!-- 海创定制的特殊费用中，仅需要个性化参数和权限控制 -->
                <el-button
                  v-if="(isAllowedEdit && !isAdjust && privilege.editSpecialCharge && viewSource!=='salesDetail' && !job.fba) || (config.isSpecialExpenseEntryFunction && privilege.editSpecialCharge)"
                  no="charge_editSpecial"
                  type="primary"
                  :disabled="!(!editing && tabCost.grid.selectedRow
                    && (tabCost.grid.selectedRow).special && Number(job.jobState) === 0 && !( tabCost.grid.selectedRow.billingUuid ||
                      tabCost.grid.selectedRow.invoiceUuid || tabCost.grid.selectedRow.billingPaymentUuid || tabCost.grid.selectedRow.confirmBillUuid
                      || tabCost.grid.selectedRow.verifiedAmount !== 0) && !(tabCost.grid.selectedRow).accountingDate && (tabCost.grid.selectedRow).chargeState === 0) || (!settleBranchEnable && !config.isSpecialExpenseEntryFunction)"
                  @click="tabChargesHP.editCostSpecial(true)"
                >{{ $t('FinanceManage.charge_editSpecial') }}
                </el-button>
                <!-- 新增改单费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && privilege.addChange && config.isCommittedAllowAddCost && viewSource!=='salesDetail'"
                  no="charge_newChange"
                  type="primary"
                  :disabled="!(job && job.jobState === 2 && job.changeState === 2) || lockArWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.addCostChange('add',true)"
                >{{ $t('FinanceManage.charge_newChange') }}
                </el-button>
                <!-- 修改改单费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && privilege.addChange && config.isCommittedAllowAddCost && viewSource!=='salesDetail'"
                  no="charge_editChange"
                  type="primary"
                  :disabled="!(job.jobState === 2 && job.changeState === 2 && tabCost.grid.selectedRow && tabCost.grid.selectedRow.adjustment && !( tabCost.grid.selectedRow.billingUuid || tabCost.grid.selectedRow.invoiceUuid || tabCost.grid.selectedRow.billingPaymentUuid || tabCost.grid.selectedRow.confirmBillUuid || tabCost.grid.selectedRow.verifiedAmount !== 0) && !tabCost.grid.selectedRow.accountingDate) || lockArWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.addCostChange('edit',true)"
                >{{ $t('FinanceManage.charge_editChange') }}
                </el-button>
                <!-- 删除改单费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && privilege.addChange && config.isCommittedAllowAddCost && viewSource!=='salesDetail'"
                  no="charge_deleteChange"
                  type="danger"
                  :disabled="!(job.jobState === 2 && job.changeState === 2 && tabCost.grid.selectedRow && tabCost.grid.selectedRow.adjustment && !( tabCost.grid.selectedRow.billingUuid || tabCost.grid.selectedRow.invoiceUuid || tabCost.grid.selectedRow.billingPaymentUuid || tabCost.grid.selectedRow.confirmBillUuid || tabCost.grid.selectedRow.verifiedAmount !== 0) && !tabCost.grid.selectedRow.accountingDate) || lockArWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.deleteAdjust(true)"
                >{{ $t('FinanceManage.charge_deleteChange') }}
                </el-button>
                <!--费用删除-->
                <el-button
                  v-if="!isAdjust && viewSource!=='salesDetail'"
                  id="btnDelete1"
                  type="danger"
                  :disabled="!(editing && tabCost.grid.selectedRow && tabChargesHP.isRowEdit(tabCost.grid.selectedRow) && tabChargesHP.checkDeletePersonalArCharge(tabCost.grid.selectedRow)) || lockArWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.deleteCost()"
                >{{ $t('FinanceManage.charge_delete') }}
                </el-button>
                <!-- 创建应收账单（从费用 Tab 直接建账，Option A） -->
                <el-button
                  v-if="!isAdjust || viewSource==='salesDetail'"
                  v-permission="['button_InternalBillInfo_accountAdd']"
                  type="success"
                  :disabled="lockArWithProvision || !settleBranchEnable || arSelectedCount === 0"
                  @click="tabChargesHP.createBillingFromCharges(true)"
                >+ {{ $t('FinanceManage.createReceivableBill') }}
                </el-button>
                <!-- 修改应收到期日 -->
                <el-button
                  v-if="showUpdateDueDate"
                  no="updateDueDateCost"
                  type="primary"
                  :disabled="!$checkPermission(['button_Charge_updateDueDateCost']) || job.pigeonhole || editing"
                  @click="tabChargesHP.updateDueDate(true)"
                >{{ $t('FinanceManage.ModifyExpirationDate') }}
                </el-button>
                <!--抄录应付-->
                <el-button
                  v-if="!isAdjust && viewSource!=='salesDetail' && !showMergeChargeItemSalesView"
                  no="charge_sp6"
                  type="primary"
                  :disabled="!(editing && privilege.copyPayable) || lockArWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.copySellingHandler()"
                >{{ $t('FinanceManage.charge_sp6') }}
                </el-button>
                <!--费用方案-->
                <el-button
                  v-if="!isAdjust && showUp && viewSource!=='salesDetail'"
                  no="charge_sp7"
                  type="primary"
                  :disabled="!(editing && privilege.chargeProject) || (lockArWithProvision && lockApWithProvision) || !settleBranchEnable"
                  @click="tabChargesHP.chargeSchemeHandler()"
                >{{ $t('FinanceManage.charge_sp7') }}
                </el-button>
                <!--销售查询 费用方案-->
                <el-button
                  v-if="privilege.salesChargePayable && viewSource==='salesDetail' && isOperating"
                  no="charge_sp7_2"
                  type="primary"
                  :disabled="!settleBranchEnable"
                  @click="tabChargesHP.chargeSchemeHandler()"
                >{{ $t('FinanceManage.charge_sp7') }}
                </el-button>
                <!--运价表-->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && viewSource!=='salesDetail' && !job.fba && !showMergeChargeItemSalesView"
                  no="charge_sp8"
                  type="primary"
                  :disabled="!(editing) || (lockArWithProvision && lockApWithProvision) || !settleBranchEnable"
                  @click="tabChargesHP.onPrice()"
                >{{ $t('FinanceManage.charge_sp8') }}
                </el-button>
                <!--提交费用-->
                <el-button
                  v-if="config.isChargeSubmitDirect && !isAdjust && privilege.isSubmitChargeRole && viewSource!=='salesDetail'"
                  no="charge_sp10"
                  type="primary"
                  :disabled="!(!editing && btnEditing) || !settleBranchEnable"
                  @click="tabChargesHP.chargeSubmitEventHandler(1,true)"
                >{{ $t('FinanceManage.charge_sp10') }}
                </el-button>
                <!--取消提交-->
                <el-button
                  v-if="config.isChargeSubmitDirect && !isAdjust && privilege.isCancelSubmitChargeRole && viewSource!=='salesDetail'"
                  no="charge_sp9"
                  type="primary"
                  :disabled="!(!editing && btnEditing) || !settleBranchEnable"
                  @click="tabChargesHP.chargeSubmitEventHandler(0,true)"
                >{{ $t('FinanceManage.charge_sp9') }}
                </el-button>
                <!-- 应收 费用审核按钮 -->
                <el-button
                  v-if="privilege.chargeAuditFlow"
                  id="btnAuditCost"
                  type="primary"
                  :disabled="(editing || (job && job.jobState === 2)) || !settleBranchEnable"
                  @click="tabChargesHP.chargeAuditHandler(true, true)"
                >{{ $t('FinanceManage.charge_chargesAudit') }}
                </el-button>
                <!-- 应收 取消审核按钮 -->
                <el-button
                  v-if="privilege.chargeAuditFlow"
                  id="btnCancelAuditCost"
                  type="primary"
                  :disabled="(editing || (job && job.jobState === 2)) || !settleBranchEnable"
                  @click="tabChargesHP.chargeAuditHandler(true, false)"
                >{{ $t('FinanceManage.charge_cancelTheAudit') }}
                </el-button>
                <!-- 费用驳回 -->
                <el-button
                  v-if="privilege.chargeAuditFlow"
                  id="btnRejectCost"
                  type="primary"
                  :disabled="(editing || (job && job.jobState === 2)) || !settleBranchEnable"
                  @click="tabChargesHP.chargeRejectHandler(true)"
                >{{ $t('FinanceManage.charge_chargesReject') }}
                </el-button>
                <!--特殊费用调整-->
                <el-button
                  v-if="isAllowedEdit && isAdjust && config.chargeModifyType !== 2 && privilege.addSpecialUpdate && viewSource!=='salesDetail'"
                  no="charge_specialUpdate"
                  type="primary"
                  width="120"
                  :disabled="!(job && job.jobState === 2) || !settleBranchEnable"
                  @click="tabChargesHP.addCostSpecial('addSpecialUpdate',true)"
                >{{ $t('FinanceManage.charge_specialUpdate') }}
                </el-button>
                <!--受控-->
                <el-button
                  v-if="privilege.isCostControlled"
                  no="controlledEventHandler"
                  type="primary"
                  :disabled="!(isAdjust ? true : editing) || !settleBranchEnable"
                  @click="tabChargesHP.controlledEventHandler(true)"
                >
                  {{
                    (!editing && !isAdjust) ? $t('FinanceManage.charge_controlled') : (isAllCostControlled ? $t('FinanceManage.charge_cancelControlled') : $t('FinanceManage.charge_controlled'))
                  }}
                </el-button>
                <!--费用分摊-->
                <el-button
                  v-if="isAllowedEdit && job.masterFlag && viewSource!=='salesDetail'"
                  no="charge_sp11"
                  type="primary"
                  :disabled="!canShareCost || !settleBranchEnable"
                  @click="tabChargesHP.shareChargeCostHandler()"
                >{{ $t('FinanceManage.charge_sp11') }}
                </el-button>

                <!--新增-->
                <!-- 财务审核 销售查询使用，但实际弹框不同-->
                <el-button
                  v-if="(isAllowedEdit && isAdjust && config.chargeModifyType > 1 && job.salesChannel !== 'eTowerOne') || (viewSource==='salesDetail' && privilege.isSalesCostAddChargeRole && job && job.jobState === 0 && job.salesChannel !== 'eTowerOne') "
                  no="charge_add"
                  type="primary"
                  :disabled="!settleBranchEnable || (viewSource==='salesDetail' && lockArWithProvision)"
                  @click="tabChargesHP.addCostAdjust('add',true,false)"
                >{{ $t('FinanceManage.charge_add') }}
                </el-button>
                <!--修改-->
                <el-button
                  v-if="(tabCost.grid.selectedRow && isAllowedEdit && isAdjust && config.chargeModifyType > 1 && viewSource!=='salesDetail') || (viewSource==='salesDetail' && privilege.isSalesCostEditChargeRole && job && job.jobState === 0)"
                  no="charge_edit"
                  type="primary"
                  :disabled="!settleBranchEnable || (viewSource==='salesDetail' && lockArWithProvision)"
                  @click="tabChargesHP.addCostAdjust('edit',true,false)"
                >{{ $t('FinanceManage.charge_edit') }}
                </el-button>
                <!--删除-->
                <el-button
                  v-if="(tabCost.grid.selectedRow && isAllowedEdit && isAdjust && config.chargeModifyType > 1 && tabChargesHP.checkRoleDelete(tabCost.grid.selectedRow)) || (viewSource==='salesDetail' && privilege.salesDeleteArDeptCharge && job && job.jobState === 0)"
                  no="charge_delete"
                  type="danger"
                  :disabled="!settleBranchEnable || (viewSource==='salesDetail' && lockArWithProvision)"
                  @click="tabChargesHP.deleteAdjust(true)"
                >{{ $t('FinanceManage.charge_delete') }}
                </el-button>

                <!--增加调整-->
                <el-button
                  v-if="isAllowedEdit && isAdjust && (privilege.isAdjustmentAddRole || privilege.isAdjustmentAddRolePositiveNum) && config.chargeModifyType !== 2 && viewSource!=='salesDetail'"
                  no="charge_newAdjustment"
                  type="primary"
                  :disabled="!(job && job.jobState === 2) || !settleBranchEnable || lockArWithProvision"
                  @click="tabChargesHP.addCostAdjust('add',true)"
                >{{ $t('FinanceManage.charge_newAdjustment') }}
                </el-button>
                <!--修改调整-->
                <el-button
                  v-if="isAllowedEdit && isAdjust && privilege.isAdjustmentEditRole && config.chargeModifyType !== 2 && viewSource!=='salesDetail'"
                  no="charge_editAdjustment"
                  type="primary"
                  :disabled="!(Number(job.jobState) === 2 && tabCost.grid.selectedRow && !( tabCost.grid.selectedRow.billingUuid || tabCost.grid.selectedRow.invoiceUuid || tabCost.grid.selectedRow.billingPaymentUuid || tabCost.grid.selectedRow.confirmBillUuid || tabCost.grid.selectedRow.verifiedAmount !== 0)) || !settleBranchEnable || lockArWithProvision"
                  @click="tabChargesHP.addCostAdjust('edit',true,true,false)"
                >{{ $t('FinanceManage.charge_editAdjustment') }}
                </el-button>
                <!--删除调整-->
                <el-button
                  v-if="isAllowedEdit && isAdjust && privilege.isAdjustmentDeleteRole && config.chargeModifyType !== 2 && viewSource!=='salesDetail'"
                  no="charge_deleteAdjustment"
                  type="danger"
                  :disabled="!(job.jobState === 2 && tabCost.grid.selectedRow && !( tabCost.grid.selectedRow.billingUuid || tabCost.grid.selectedRow.invoiceUuid || tabCost.grid.selectedRow.billingPaymentUuid || tabCost.grid.selectedRow.confirmBillUuid || tabCost.grid.selectedRow.verifiedAmount !== 0)) || !settleBranchEnable || lockArWithProvision"
                  @click="tabChargesHP.addCostAdjust('del',true,true,false)"
                >{{ $t('FinanceManage.charge_deleteAdjustment') }}
                </el-button>
                <el-button
                  v-if="privilege.reconciliationDiffAr"
                  no="reconciliationDiffAr"
                  type="primary"
                  @click="tabChargesHP.reconciliationDiff(true)"
                >{{ $t('CargoMsg.Cargo_ReconciliationDiffConfirm') }}
                </el-button>
                <!--销账明细-->
                <el-button
                  id="btnVerified"
                  type="primary"
                  :disabled="!(tabCost.grid.selectedRow && tabCost.grid.selectedRow.clearingDate) || !settleBranchEnable"
                  @click="tabChargesHP.btnVerifiedCost_clickHandler()"
                >{{ $t('FinanceManage.charge_writeOffList') }}
                </el-button>
                <template v-if="arChargeSyncBtns.length <= 1">
                  <!--费用同步-->
                  <el-button
                    v-if="config.openMutualTrustConfig !== 0"
                    no="btnAsyncCharges"
                    type="primary"
                    :disabled="!arChargeSyncEnabled || editing || !settleBranchEnable"
                    @click="tabChargesHP.syncEntrustChargers()"
                  >{{ $t('FinanceManage.charge_asyncCharges') }}
                  </el-button>
                  <!--费用同步（海运出口同步到进口）-->
                  <el-button
                    v-if="job.lob==='SE'&&config.enableEntrustmentSI&&config.chargeSyncNeedConfirm"
                    no="btnSyncArChargesSE"
                    type="primary"
                    :disabled="!arChargeSyncEnabled || editing || !settleBranchEnable"
                    @click="tabChargesHP.syncChargesToImportJob(true)"
                  >{{ $t('FinanceManage.charge_asyncCharges') }}
                  </el-button>
                  <!--费用同步（海运进口同步到出口）-->
                  <el-button
                    v-if="job.lob==='SI'&&config.enableEntrustmentSI"
                    no="btnSyncArChargesSI"
                    type="primary"
                    :disabled="!arChargeSyncEnabled || editing || !settleBranchEnable"
                    @click="tabChargesHP.syncChargesToExportJob(true)"
                  >{{ $t('FinanceManage.charge_asyncCharges') }}
                  </el-button>
                  <!--费用同步（空运出口同步到进口）-->
                  <el-button
                    v-if="job.lob==='AE'&&config.consignationImportByAE&&config.chargeSyncNeedConfirm"
                    no="btnSyncArChargesAE"
                    type="primary"
                    :disabled="!arChargeSyncEnabled || editing || !settleBranchEnable"
                    @click="tabChargesHP.syncChargesToImportJob(true)"
                  >{{ $t('FinanceManage.charge_asyncCharges') }}
                  </el-button>
                  <!--费用同步（空运进口同步到出口）-->
                  <el-button
                    v-if="job.lob==='AI'&&config.consignationImportByAE"
                    no="btnSyncArChargesAI"
                    type="primary"
                    :disabled="!arChargeSyncEnabled || editing || !settleBranchEnable"
                    @click="tabChargesHP.syncChargesToExportJob(true)"
                  >{{ $t('FinanceManage.charge_asyncCharges') }}
                  </el-button>
                </template>
                <template v-if="arChargeSyncBtns.length > 1">
                  <el-dropdown
                    split-button
                    type="primary"
                    :disabled="!arChargeSyncEnabled || editing || !settleBranchEnable"
                    style="margin:0 5px"
                    @click="tabChargesHP.arChargeSyncHandler()"
                    @command="p=>{arChargeSyncCommand=p;tabChargesHP.arChargeSyncHandler()}"
                  >
                    {{ arChargeSyncCommand }}
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="(item,index) in arChargeSyncBtns" :key="index" :command="item.name">{{ item.name }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
                <!-- 同步云星空 -->
                <el-button
                  v-if="$checkPermission(['button_financeModule_audit']) && config.jinRongExchangeMode"
                  no="syncCloudStarrySkyAr"
                  :disabled="editing || job.jobState !== 2"
                  type="primary"
                  @click="tabChargesHP.syncCloudStarrySky(true)"
                >{{ $t('FinanceManage.SyncCloudStarrySky') }}
                </el-button>
                <!-- 申请新增费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && !batchAmendmentFee && privilege.applyAddCharge && config.applyChangeChargeButton && viewSource!=='salesDetail'"
                  no="applyAddCharge"
                  type="primary"
                  :disabled="!(job.jobState === 2) || !settleBranchEnable || (config.toExoSystemHC && lockArWithProvision)"
                  @click="tabChargesHP.applyChangeCharge('add',true)"
                >{{ $t('ChangeCharge.applyAddCharge') }}
                </el-button>
                <!-- 申请更改费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && privilege.applyChangeCharge && config.applyChangeChargeButton && viewSource!=='salesDetail'"
                  no="applyChangeCharge"
                  type="primary"
                  :disabled="!(job.jobState === 2 || (job.jobState === 1 && batchAmendmentFee)) || !settleBranchEnable || (config.toExoSystemHC && lockArWithProvision)"
                  @click="tabChargesHP.applyChangeCharge('edit',true)"
                >{{ $t('ChangeCharge.applyChangeCharge') }}
                </el-button>
                <!-- 申请删除费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && !batchAmendmentFee && privilege.applyDeleteCharge && config.applyChangeChargeButton && viewSource!=='salesDetail'"
                  no="applyDeleteCharge"
                  type="danger"
                  :disabled="!(job.jobState === 2) || !settleBranchEnable || (config.toExoSystemHC && lockArWithProvision)"
                  @click="tabChargesHP.applyChangeCharge('del', true)"
                >{{ $t('ChangeCharge.applyDeleteCharge') }}
                </el-button>
                <!-- 申请更改中的费用 -->
                <el-button
                  v-if="privilege.applyChangeCharge && config.applyChangeChargeButton && viewSource!=='salesDetail' && !batchAmendmentFee"
                  no="showChangingCharge"
                  type="primary"
                  :disabled="!(job.jobState === 2)"
                  @click="tabChargesHP.showApplyChangingCharge()"
                >{{ $t('ChangeCharge.showApplyChangingCharge') }}
                </el-button>
                <el-button
                  v-if="job.relatedJob && !editing && !isCrossTenantSeToSi && !config.chargeSyncNeedConfirm"
                  no="asyncChargesToImportJob"
                  type="primary"
                  :disabled="!settleBranchEnable"
                  @click="tabChargesHP.asyncChargesToImportJob(true)"
                >{{ $t('FinanceManage.charge_asyncChargesToImportJob') }}
                </el-button>
                <!-- 带入约价 -->
                <el-button
                  v-if="isAllowedEdit && privilege.generateChargeByContractNo && config.contractBinding && viewSource!=='salesDetail' && job.lob === 'SE'"
                  no="generateByContract"
                  type="primary"
                  :disabled="!(!editing && btnEditing && job.jobState === 0) || !settleBranchEnable"
                  @click="tabChargesHP.generateChargeByContractNo()"
                >{{ $t('ChangeCharge.generateByContract') }}
                </el-button>
                <!--锁定应收-->
                <el-button
                  v-show="$checkPermission(['button_Charge_lockReceivable']) && !lockArWithProvision && showLockButton && viewSource!=='salesDetail'"
                  no="LockAr"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.modifyChargeLockStatus(true, 1)"
                >{{ $t('SeaExport.LockAr') }}
                </el-button>
                <!--撤销锁定应收-->
                <el-button
                  v-show="lockArWithProvision && showLockButton && viewSource!=='salesDetail'"
                  no="UnLockAr"
                  type="primary"
                  :disabled="editing || !settleBranchEnable || !$checkPermission(['button_Charge_unLockReceivable'])"
                  @click="tabChargesHP.modifyChargeLockStatus(true, 0)"
                >{{ $t('SeaExport.UnLockAr') }}
                </el-button>
                <!--同步确认费用-->
                <el-button
                  v-if="isAllowedEdit && job.lob === 'SI' && job.trustFromJob && isCrossTenantSeToSi"
                  no="syncChargesConfirmStatus"
                  type="primary"
                  :disabled="editing || !(job.jobState === -1 || job.jobState === 0) || !settleBranchEnable"
                  @click="tabChargesHP.updateChargeSyncConfirmStatus(1)"
                >{{ $t('FinanceManage.charge_syncChargesConfirmStatus') }}
                </el-button>
                <!--取消同步确认费用-->
                <el-button
                  v-if="isAllowedEdit && job.lob === 'SI' && job.trustFromJob && isCrossTenantSeToSi"
                  no="cancelSyncChargesConfirmStatus"
                  type="primary"
                  :disabled="editing || !(job.jobState === -1 || job.jobState === 0) || !settleBranchEnable"
                  @click="tabChargesHP.updateChargeSyncConfirmStatus(0)"
                >{{ $t('FinanceManage.charge_cancelSyncChargesConfirmStatus') }}
                </el-button>
                <!--跨租户出转进-费用同步-->
                <el-button
                  v-if="job.relatedJob && !editing && isCrossTenantSeToSi"
                  no="syncChargesToSI"
                  type="primary"
                  :disabled="job.jobState !== 0 || !settleBranchEnable"
                  @click="tabChargesHP.crossTenantSEToSICharge(1)"
                >{{ $t('FinanceManage.charge_syncChargesToSI') }}
                </el-button>
                <!--跨租户出转进-取消费用同步-->
                <el-button
                  v-if="job.relatedJob && !editing && isCrossTenantSeToSi"
                  no="cancelSyncChargesToSI"
                  type="primary"
                  :disabled="job.jobState !== 0 || !settleBranchEnable"
                  @click="tabChargesHP.crossTenantSEToSICharge(0)"
                >{{ $t('FinanceManage.charge_cancelSyncChargesToSI') }}
                </el-button>
                <!--EAS同步应收-->
                <el-button
                  v-show="$checkPermission(['button_Charge_easSync']) && config.toExoSystemEAS && showLockButton && viewSource!=='salesDetail'"
                  no="SyncChargeToEas"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.syncChargeToEas(true)"
                >{{ $t('SeaExport.SyncChargeToEas') }}
                </el-button>
                <!--费用同步记录-->
                <el-button
                  v-if="showChargeSyncRecord"
                  no="btnChargeSyncRecord"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.showChargeSyncRecord()"
                >{{ $t('FinanceManage.charge_asyncChargeRecords') }}
                </el-button>
                <!-- 修改追加费用备注 -->
                <el-button
                  v-if="isBusinessModuleList && privilege.updateRemarkCharge"
                  no="updateRemarks"
                  type="primary"
                  :disabled="!isOperating"
                  @click="tabChargesHP.updateRemark(true)"
                >{{ $t('FinanceManage.AdditionalCostRemarks') }}
                </el-button>
                <el-button
                  v-if="isBusinessFinanceManage && privilege.updateRemarkCharge"
                  no="updateRemarks"
                  type="primary"
                  @click="tabChargesHP.updateRemark(true)"
                >{{ $t('FinanceManage.AdditionalCostRemarks') }}
                </el-button>
              </div>
            </cargo-button-group-slider>

          </div>
          <div class="filters" />
        </div>
        <cargo-ag-grid-wrapper
          ref="tabCostGrid"
          no="130111"
          :grid-options="tabCost.grid.gridOptions"
          :column-defs="dynamicColumnDefsForCost"
          :sum-column-defs="arSumColumnDefs"
          :grid-params.sync="tabCost.grid.gridParams"
          config-module="130111"
          :row-data="tabCost.grid.overseaCostDetails"
          :cancel-sort-auto-reduce="false"
          style="flex-grow:1;margin-top:10px;padding-right: 10px;"
          min-height="100px"
          :show-row-groups="dataListDragGroup"
          :has-export-role="!customerSalesDisplay || (customerSalesDisplay && !(this.viewSource === 'RemoteBooking' || this.viewSource === 'salesDetail'))"
          :pre-column-state-callback="preColumnStateCallback"
          @gridReady="onCostGridReady"
          @columnRowGroupChanged="tabCost.grid.groupColumns = $event; tabCost.grid.groupRowNode = {}"
        />
      </template>
      <!--      应付-->
      <template slot="down">
        <div v-if="isBpm">
          <span>{{ $t('SeaExport.payable') }}</span>
        </div>
        <div v-if="!isBpm" class="operations" :style="{marginTop: showUp ? '10px' : ''}">
          <div class="triggers">
            <div>
              <span>{{ $t('SeaExport.payable') }}</span>
              <charge-currency-total-group
                v-if="reCalc"
                ref="apTotalGroup"
                no="apTotalGroup"
                :amount-to-currency="localCurrency"
                :data-provider="apTotalGroup.dataProvider"
                :data-field="config._isCalculateExcludingAmount ? 'amount' : 'excludingTaxAmount'"
                rate-field="exchangeRate"
                :is-gross-profit="true"
                :show-controlled-profit="privilege.showControlledProfit"
                :show-controlled="privilege.isControlled"
                type="ap"
                source="chargeDetailAp"
                :auxiliary-map="arAuxiliaryDataMap"
              />
              <span v-show="showEstimate">
                <span>(</span>
                <span>{{ $t("FinanceManage.charge_estimate") }}</span>
                <!--应付预估 job.estimateAccountsPayable-->
                <span style="text-decoration: underline;">{{ estimateAccountsPayable }}</span>
                <span>)</span>
              </span>
            </div>
            <cargo-button-group-slider v-if="!showMergeChargeItemSalesView" no="bottom" align="right" style="flex:1; border: none">
              <div>
                <!--抄录费用-->
                <el-button
                  v-show="viewSource!=='salesDetail'"
                  v-if="job && job.jobState === 0 && privilege.copyCharge && !showUp"
                  id="btnCpoyCharge2"
                  type="primary"
                  :disabled="!editing || (lockArWithProvision && lockApWithProvision) || !settleBranchEnable"
                  @click="tabChargesHP.cpoyChargeHandler()"
                >{{ $t('FinanceManage.charge_copyCharge') }}
                </el-button>
                <!--同步云平台-->
                <el-button
                  v-if="job && config.toExoSystemYGSH"
                  id="btnSynchronizationLtsChargeAp"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.synchronizationLtsCharge(false)"
                >{{ $t('CargoMsg.Cargo_SynchronousCloudPlatform') }}
                </el-button>
                <el-button
                  v-show="!isAdjust && privilege.isCostAddChargeRole && viewSource!=='salesDetail'"
                  id="btnAdd2"
                  type="primary"
                  :disabled="!(editing) || lockApWithProvision || !settleBranchEnable"
                  @click="addSellingEventFlag=true"
                >{{ $t('FinanceManage.charge_add') }}
                </el-button>
                <!--复制费用-->
                <el-button
                  v-show="!isAdjust && privilege.isCostAddChargeRole && viewSource!=='salesDetail'"
                  id="btnCopy2"
                  type="primary"
                  :disabled="!(editing) || lockApWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.copyCharge(false)"
                >{{ $t('FinanceManage.charge_copy') }}
                </el-button>
                <!--修改结算对象-->
                <el-button
                  v-show="!isAdjust && viewSource!=='salesDetail' && showApChargeAuditButton"
                  id="btnChangeSettlementAp"
                  type="primary"
                  :disabled="!(editing) || lockApWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.changeAccountHandler(false)"
                >{{ $t('CargoMsg.Cargo_ChangeSettlement') }}
                </el-button>
                <!-- 新增特殊费用 -->
                <!-- 海创定制的特殊费用中，仅需要个性化参数和权限控制 -->
                <el-button
                  v-if="(isAllowedEdit && !isAdjust && privilege.addSpecialCharge && viewSource!=='salesDetail' && !job.fba) || (config.isSpecialExpenseEntryFunction && privilege.addSpecialCharge)"
                  id="addCostSpecialOSButton"
                  type="primary"
                  :disabled="!(btn.addCostSpecialOCButton.enabled) || !settleBranchEnable"
                  @click="tabChargesHP.addCostSpecial('add',false)"
                >{{ $t('FinanceManage.charge_newSpecial') }}
                </el-button>
                <!-- 编辑特殊费用 -->
                <!-- 海创定制的特殊费用中，仅需要个性化参数和权限控制 -->
                <el-button
                  v-if="(isAllowedEdit && !isAdjust && privilege.editSpecialCharge && viewSource!=='salesDetail' && !job.fba) || (config.isSpecialExpenseEntryFunction && privilege.editSpecialCharge)"
                  no="charge_editSpecial"
                  type="primary"
                  :disabled="!(!editing && tabSelling.grid.selectedRow
                    && (tabSelling.grid.selectedRow).special && job.jobState === 0 &&!( tabSelling.grid.selectedRow.billingUuid || tabSelling.grid.selectedRow.invoiceUuid
                      || tabSelling.grid.selectedRow.billingPaymentUuid || tabSelling.grid.selectedRow.confirmBillUuid || tabSelling.grid.selectedRow.verifiedAmount !== 0)
                    && !tabSelling.grid.selectedRow.accountingDate && (tabSelling.grid.selectedRow).chargeState === 0) || (!settleBranchEnable && !config.isSpecialExpenseEntryFunction)"
                  @click="tabChargesHP.editCostSpecial(false)"
                >{{ $t('FinanceManage.charge_editSpecial') }}
                </el-button>
                <!-- 新增商务特殊费用（仅应付栏） -->
                <el-button
                  v-if="config.isSpecialExpenseEntryFunction && privilege.addBusinessSpecialCharge"
                  id="addCostBusinessSpecialButton"
                  type="primary"
                  :disabled="!(btn.addCostBusinessSpecialButton.enabled) || !settleBranchEnable"
                  @click="tabChargesHP.addCostBusinessSpecial('add')"
                >{{ $t('FinanceManage.charge_newBusinessSpecial') }}
                </el-button>
                <!-- 编辑商务特殊费用（仅应付栏） -->
                <el-button
                  v-if="config.isSpecialExpenseEntryFunction && privilege.editBusinessSpecialCharge"
                  no="charge_editBusinessSpecial"
                  type="primary"
                  :disabled="!(!editing && tabSelling.grid.selectedRow
                    && (tabSelling.grid.selectedRow).businessSpecial && job.jobState === 0 &&!( tabSelling.grid.selectedRow.billingUuid || tabSelling.grid.selectedRow.invoiceUuid
                      || tabSelling.grid.selectedRow.billingPaymentUuid || tabSelling.grid.selectedRow.confirmBillUuid || tabSelling.grid.selectedRow.verifiedAmount !== 0)
                    && !tabSelling.grid.selectedRow.accountingDate && (tabSelling.grid.selectedRow).chargeState === 0) || !settleBranchEnable"
                  @click="tabChargesHP.editCostBusinessSpecial()"
                >{{ $t('FinanceManage.charge_editBusinessSpecial') }}
                </el-button>
                <!-- 新增改单费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && privilege.addChange && config.isCommittedAllowAddCost && viewSource!=='salesDetail'"
                  no="charge_newChange"
                  type="primary"
                  :disabled="!(job && job.jobState === 2 && job.changeState === 2) || lockApWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.addCostChange('add',false)"
                >{{ $t('FinanceManage.charge_newChange') }}
                </el-button>
                <!-- 修改改单费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && privilege.addChange && config.isCommittedAllowAddCost && viewSource!=='salesDetail'"
                  no="charge_editChange"
                  type="primary"
                  :disabled="!(job.jobState === 2 && job.changeState === 2 && tabSelling.grid.selectedRow && tabSelling.grid.selectedRow.adjustment && !( tabSelling.grid.selectedRow.billingUuid || tabSelling.grid.selectedRow.invoiceUuid || tabSelling.grid.selectedRow.billingPaymentUuid || tabSelling.grid.selectedRow.confirmBillUuid || tabSelling.grid.selectedRow.verifiedAmount !== 0) && !tabSelling.grid.selectedRow.accountingDate) || lockApWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.addCostChange('edit',false)"
                >{{ $t('FinanceManage.charge_editChange') }}
                </el-button>
                <!-- 删除改单费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && privilege.addChange && config.isCommittedAllowAddCost && viewSource!=='salesDetail'"
                  no="charge_deleteChange"
                  type="danger"
                  :disabled="!(job.jobState === 2 && job.changeState === 2 && tabSelling.grid.selectedRow && tabSelling.grid.selectedRow.adjustment && !( tabSelling.grid.selectedRow.billingUuid || tabSelling.grid.selectedRow.invoiceUuid || tabSelling.grid.selectedRow.billingPaymentUuid || tabSelling.grid.selectedRow.confirmBillUuid || tabSelling.grid.selectedRow.verifiedAmount !== 0) && !tabSelling.grid.selectedRow.accountingDate) || lockApWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.deleteAdjust(false)"
                >{{ $t('FinanceManage.charge_deleteChange') }}
                </el-button>
                <!-- 删除费用 -->
                <el-button
                  v-if="!isAdjust && viewSource!=='salesDetail'"
                  id="btnDelete2"
                  type="danger"
                  :disabled="!(editing && tabSelling.grid.selectedRow && tabChargesHP.isRowEdit(tabSelling.grid.selectedRow) && tabChargesHP.checkDeletePersonalApCharge(tabSelling.grid.selectedRow)) || lockApWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.deleteSelling()"
                >{{ $t('FinanceManage.charge_delete') }}
                </el-button>
                <!-- 创建应付账单（从费用 Tab 直接建账，Option A） -->
                <el-button
                  v-if="!isAdjust || viewSource==='salesDetail'"
                  v-permission="['button_InternalBillInfo_payAdd']"
                  type="success"
                  :disabled="lockApWithProvision || !settleBranchEnable || apSelectedCount === 0"
                  @click="tabChargesHP.createBillingFromCharges(false)"
                >+ {{ $t('FinanceManage.createPayableBill') }}
                </el-button>
                <!-- 修改应付到期日 -->
                <el-button
                  v-if="showUpdateDueDate"
                  no="updateDueDateSell"
                  type="primary"
                  :disabled="!$checkPermission(['button_Charge_updateDueDateSell']) || job.pigeonhole || editing"
                  @click="tabChargesHP.updateDueDate(false)"
                >{{ $t('FinanceManage.ModifyExpirationDate') }}
                </el-button>
                <el-button
                  v-if="!isAdjust && viewSource!=='salesDetail'"
                  no="charge_copyCost"
                  type="primary"
                  :disabled="!(editing && privilege.copyReceivable) || lockApWithProvision || !settleBranchEnable"
                  @click="tabChargesHP.copyCostHandler()"
                >{{ $t('FinanceManage.charge_copyCost') }}
                </el-button>
                <!--费用方案-->
                <el-button
                  v-if="!isAdjust && !showUp && viewSource!=='salesDetail'"
                  no="charge_sp7"
                  type="primary"
                  :disabled="!(editing) || !settleBranchEnable"
                  @click="tabChargesHP.chargeSchemeHandler()"
                >{{ $t('FinanceManage.charge_sp7') }}
                </el-button>
                <!--提交费用-->
                <el-button
                  v-if="config.isChargeSubmitDirect && !isAdjust && privilege.isSubmitChargeRole && viewSource!=='salesDetail'"
                  no="charge_sp10"
                  type="primary"
                  :disabled="!(!editing && btnEditing) || !settleBranchEnable"
                  @click="tabChargesHP.chargeSubmitEventHandler(1)"
                >{{ $t('FinanceManage.charge_sp10') }}
                </el-button>
                <!--取消提交-->
                <el-button
                  v-if="config.isChargeSubmitDirect && !isAdjust && privilege.isCancelSubmitChargeRole && viewSource!=='salesDetail'"
                  no="charge_sp9"
                  type="primary"
                  :disabled="!(!editing && btnEditing) || !settleBranchEnable"
                  @click="tabChargesHP.chargeSubmitEventHandler(0)"
                >{{ $t('FinanceManage.charge_sp9') }}
                </el-button>
                <!-- 应付 费用审核按钮 -->
                <el-button
                  v-if="privilege.chargeAuditFlow"
                  id="btnAuditSelling"
                  type="primary"
                  :disabled="(editing || (job && job.jobState === 2)) || !settleBranchEnable"
                  @click="tabChargesHP.chargeAuditHandler(false, true)"
                >{{ $t('FinanceManage.charge_chargesAudit') }}
                </el-button>
                <!-- 应付 取消审核按钮 -->
                <el-button
                  v-if="privilege.chargeAuditFlow"
                  id="btnCancelAuditSelling"
                  type="primary"
                  :disabled="(editing || (job && job.jobState === 2)) || !settleBranchEnable"
                  @click="tabChargesHP.chargeAuditHandler(false, false)"
                >{{ $t('FinanceManage.charge_cancelTheAudit') }}
                </el-button>
                <!-- 费用驳回 -->
                <el-button
                  v-if="privilege.chargeAuditFlow"
                  id="btnRejectSelling"
                  type="primary"
                  :disabled="(editing || (job && job.jobState === 2)) || !settleBranchEnable"
                  @click="tabChargesHP.chargeRejectHandler(false)"
                >{{ $t('FinanceManage.charge_chargesReject') }}
                </el-button>
                <!--特殊费用调整-->
                <el-button
                  v-if="isAllowedEdit && isAdjust && config.chargeModifyType !== 2 && privilege.addSpecialUpdate && viewSource!=='salesDetail'"
                  no="charge_specialUpdate"
                  type="primary"
                  width="120"
                  :disabled="!(job && job.jobState === 2) || !settleBranchEnable"
                  @click="tabChargesHP.addCostSpecial('addSpecialUpdate',false)"
                >{{ $t('FinanceManage.charge_specialUpdate') }}</el-button>
                <!--受控-->
                <el-button
                  v-if="privilege.isControlled"
                  no="controlledEventHandler"
                  type="primary"
                  :disabled="!(isAdjust ? true : editing) || !settleBranchEnable"
                  @click="tabChargesHP.controlledEventHandler(false)"
                >
                  {{
                    (!editing && !isAdjust) ? $t('FinanceManage.charge_controlled') : (isAllSellingControlled ? $t('FinanceManage.charge_cancelControlled') : $t('FinanceManage.charge_controlled'))
                  }}
                </el-button>

                <el-button
                  v-if="(isAllowedEdit && isAdjust && config.chargeModifyType > 1 && job.salesChannel !== 'eTowerOne') || (viewSource==='salesDetail' && privilege.isSalesPayAddChargeRole && job && job.jobState === 0 && job.salesChannel !== 'eTowerOne')"
                  no="charge_add"
                  type="primary"
                  :disabled="!settleBranchEnable || (viewSource==='salesDetail' && lockApWithProvision)"
                  @click="tabChargesHP.addCostAdjust('add',false,false)"
                >{{ $t('FinanceManage.charge_add') }}
                </el-button>
                <el-button
                  v-if="(tabSelling.grid.selectedRow && isAllowedEdit && isAdjust && config.chargeModifyType > 1 && viewSource!=='salesDetail') || (viewSource==='salesDetail' && privilege.isSalesPayEditChargeRole && job && job.jobState === 0)"
                  no="charge_edit"
                  type="primary"
                  :disabled="!settleBranchEnable || (viewSource==='salesDetail' && lockApWithProvision)"
                  @click="tabChargesHP.addCostAdjust('edit',false,false)"
                >{{ $t('FinanceManage.charge_edit') }}
                </el-button>
                <el-button
                  v-if="(tabSelling.grid.selectedRow && isAllowedEdit && isAdjust && config.chargeModifyType > 1) || (viewSource==='salesDetail' && privilege.salesDeleteApDeptCharge && job && job.jobState === 0)"
                  no="charge_delete"
                  type="danger"
                  :disabled="!settleBranchEnable || (viewSource==='salesDetail' && lockApWithProvision)"
                  @click="tabChargesHP.deleteAdjust(false)"
                >{{ $t('FinanceManage.charge_delete') }}
                </el-button>

                <!--增加调整-->
                <el-button
                  v-if="isAllowedEdit && isAdjust && (privilege.isAdjustmentAddRole || privilege.isAdjustmentAddRolePositiveNum) && config.chargeModifyType !== 2 && viewSource!=='salesDetail'"
                  no="charge_newAdjustment"
                  type="primary"
                  :disabled="!(job.jobState === 2) || !settleBranchEnable || lockApWithProvision"
                  @click="tabChargesHP.addCostAdjust('add',false)"
                >{{ $t('FinanceManage.charge_newAdjustment') }}
                </el-button>
                <!--修改调整-->
                <el-button
                  v-if="isAllowedEdit && isAdjust && privilege.isAdjustmentEditRole && config.chargeModifyType !== 2 && viewSource!=='salesDetail'"
                  no="charge_editAdjustment"
                  type="primary"
                  :disabled="!(Number(job.jobState) === 2 && tabSelling.grid.selectedRow && !(tabSelling.grid.selectedRow.billingUuid || tabSelling.grid.selectedRow.invoiceUuid || tabSelling.grid.selectedRow.billingPaymentUuid || tabSelling.grid.selectedRow.confirmBillUuid || tabSelling.grid.selectedRow.verifiedAmount !== 0)) || !settleBranchEnable || lockApWithProvision"
                  @click="tabChargesHP.addCostAdjust('edit',false,true,false)"
                >{{ $t('FinanceManage.charge_editAdjustment') }}
                </el-button>
                <!--删除调整-->
                <el-button
                  v-if="isAllowedEdit && isAdjust && privilege.isAdjustmentDeleteRole && config.chargeModifyType !== 2 && viewSource!=='salesDetail'"
                  no="charge_deleteAdjustment"
                  type="danger"
                  :disabled="!(job.jobState === 2 && tabSelling.grid.selectedRow && !(tabSelling.grid.selectedRow.billingUuid || tabSelling.grid.selectedRow.invoiceUuid || tabSelling.grid.selectedRow.billingPaymentUuid || tabSelling.grid.selectedRow.confirmBillUuid || tabSelling.grid.selectedRow.verifiedAmount !== 0)) || !settleBranchEnable || lockApWithProvision"
                  @click="tabChargesHP.addCostAdjust('del',false,true,false)"
                >{{ $t('FinanceManage.charge_deleteAdjustment') }}
                </el-button>
                <!--费用分摊-->
                <el-button
                  v-if="isAllowedEdit && job.masterFlag && viewSource!=='salesDetail'"
                  no="charge_sp11"
                  type="primary"
                  :disabled="!canShareSelling || !settleBranchEnable"
                  @click="tabChargesHP.shareChargeSellingHandler()"
                >{{ $t('FinanceManage.charge_sp11') }}
                </el-button>
                <el-button
                  v-if="privilege.reconciliationDiffAp"
                  no="reconciliationDiffAp"
                  type="primary"
                  @click="tabChargesHP.reconciliationDiff(false)"
                >{{ $t('CargoMsg.Cargo_ReconciliationDiffConfirm') }}
                </el-button>
                <el-button
                  no="charge_writeOffList"
                  type="primary"
                  :disabled="!(tabSelling.grid.selectedRow && tabSelling.grid.selectedRow.clearingDate) || !settleBranchEnable"
                  @click="tabChargesHP.btnVerifiedSelling_clickHandler()"
                >{{ $t('FinanceManage.charge_writeOffList') }}
                </el-button>
                <!--费用同步（海运出口同步到进口）-->
                <el-button
                  v-if="job.lob==='SE'&&config.enableEntrustmentSI&&config.chargeSyncNeedConfirm"
                  no="btnSyncApChargesSE"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.syncChargesToImportJob(false)"
                >{{ $t('FinanceManage.charge_asyncCharges') }}
                </el-button>
                <!--费用同步（海运进口同步到出口）-->
                <el-button
                  v-if="job.lob==='SI'&&config.enableEntrustmentSI"
                  no="btnSyncApChargesSI"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.syncChargesToExportJob(false)"
                >{{ $t('FinanceManage.charge_asyncCharges') }}
                </el-button>
                <!--费用同步（空运出口同步到进口）-->
                <el-button
                  v-if="job.lob==='AE'&&config.consignationImportByAE&&config.chargeSyncNeedConfirm"
                  no="btnSyncApChargesAE"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.syncChargesToImportJob(false)"
                >{{ $t('FinanceManage.charge_asyncCharges') }}
                </el-button>
                <!--费用同步（空运进口同步到出口）-->
                <el-button
                  v-if="job.lob==='AI'&&config.consignationImportByAE"
                  no="btnSyncApChargesAI"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.syncChargesToExportJob(false)"
                >{{ $t('FinanceManage.charge_asyncCharges') }}
                </el-button>
                <!-- 同步云星空 -->
                <el-button
                  v-if="$checkPermission(['button_financeModule_audit']) && config.jinRongExchangeMode"
                  no="syncCloudStarrySkyAp"
                  :disabled="editing || job.jobState !== 2"
                  type="primary"
                  @click="tabChargesHP.syncCloudStarrySky(false)"
                >{{ $t('FinanceManage.SyncCloudStarrySky') }}
                </el-button>
                <!-- 申请新增费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && !batchAmendmentFee && privilege.applyAddCharge && config.applyChangeChargeButton && viewSource!=='salesDetail'"
                  no="applyAddCharge"
                  type="primary"
                  :disabled="!(job.jobState === 2) || !settleBranchEnable || (config.toExoSystemHC && lockApWithProvision)"
                  @click="tabChargesHP.applyChangeCharge('add',false)"
                >{{ $t('ChangeCharge.applyAddCharge') }}
                </el-button>
                <!-- 申请更改费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && privilege.applyChangeCharge && config.applyChangeChargeButton && viewSource!=='salesDetail'"
                  no="applyChangeCharge"
                  type="primary"
                  :disabled="!(job.jobState === 2 || (job.jobState === 1 && batchAmendmentFee)) || !settleBranchEnable || (config.toExoSystemHC && lockApWithProvision)"
                  @click="tabChargesHP.applyChangeCharge('edit',false)"
                >{{ $t('ChangeCharge.applyChangeCharge') }}
                </el-button>
                <!-- 申请删除费用 -->
                <el-button
                  v-if="isAllowedEdit && !isAdjust && !batchAmendmentFee && privilege.applyDeleteCharge && config.applyChangeChargeButton && viewSource!=='salesDetail'"
                  no="applyDeleteCharge"
                  type="danger"
                  :disabled="!(job.jobState === 2) || !settleBranchEnable || (config.toExoSystemHC && lockApWithProvision)"
                  @click="tabChargesHP.applyChangeCharge('del', false)"
                >{{ $t('ChangeCharge.applyDeleteCharge') }}
                </el-button>
                <el-button
                  v-if="job.relatedJob && !editing && !isCrossTenantSeToSi && !config.chargeSyncNeedConfirm"
                  no="asyncChargesToImportJob"
                  type="primary"
                  :disabled="!settleBranchEnable"
                  @click="tabChargesHP.asyncChargesToImportJob(false)"
                >{{ $t('FinanceManage.charge_asyncChargesToImportJob') }}
                </el-button>
                <!--锁定应付-->
                <el-button
                  v-show="$checkPermission(['button_Charge_lockPayable']) && !lockApWithProvision && showLockButton"
                  no="LockAp"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.modifyChargeLockStatus(false, 1)"
                >{{ $t('SeaExport.LockAp') }}
                </el-button>
                <!--撤销锁定应付-->
                <el-button
                  v-show="lockApWithProvision && showLockButton"
                  no="UnLockAp"
                  type="primary"
                  :disabled="editing || !settleBranchEnable || !$checkPermission(['button_Charge_unLockPayable'])"
                  @click="tabChargesHP.modifyChargeLockStatus(false, 0)"
                >{{ $t('SeaExport.UnLockAp') }}
                </el-button>
                <!--EAS同步应付-->
                <el-button
                  v-show="$checkPermission(['button_Charge_easSync']) && config.toExoSystemEAS && showLockButton && viewSource!=='salesDetail'"
                  no="SyncChargeToEas"
                  type="primary"
                  :disabled="editing || !settleBranchEnable"
                  @click="tabChargesHP.syncChargeToEas(false)"
                >{{ $t('SeaExport.SyncChargeToEas') }}
                </el-button>
                <!-- 修改追加费用备注 -->
                <el-button
                  v-if="isBusinessModuleList && privilege.updateRemarkCharge"
                  no="updateRemarks"
                  type="primary"
                  :disabled="!isOperating"
                  @click="tabChargesHP.updateRemark(false)"
                >{{ $t('FinanceManage.AdditionalCostRemarks') }}
                </el-button>
                <el-button
                  v-if="isBusinessFinanceManage && privilege.updateRemarkCharge"
                  no="updateRemarks"
                  type="primary"
                  @click="tabChargesHP.updateRemark(false)"
                >{{ $t('FinanceManage.AdditionalCostRemarks') }}
                </el-button>
                <el-button v-show="$checkPermission(['button_Charge_businessQuotation'])" type="primary" @click="tabChargesHP.businessQuotationChange(true)">
                  {{ $t('CargoMsg.Cargo_BusinessQuotationConfirmed') }}
                </el-button>
                <el-button v-show="$checkPermission(['button_Charge_businessQuotation'])" type="primary" @click="tabChargesHP.businessQuotationChange(false)">
                  {{ $t('CargoMsg.Cargo_BusinessQuotationConfirmedCancel') }}
                </el-button>
                <!--费用同步按钮 - 应付费用同步（relatedJob为空且trustFromJob有值时可用）-->
                <el-button
                  v-if="$checkPermission(['tab_Charge_chargePayable'])"
                  no="btnSyncPayableCharge"
                  type="primary"
                  :disabled="!(!job.relatedJob && job.trustFromJob)"
                  @click="tabChargesHP.syncPayableCharge()"
                >{{ $t('FinanceManage.charge_syncPayable') }}
                </el-button>
              </div>
            </cargo-button-group-slider>
          </div>
          <div class="filters" />
        </div>
        <cargo-ag-grid-wrapper
          v-show="!showMergeChargeItemSalesView"
          ref="tabSellingGrid"
          no="130112"
          :grid-options="tabSelling.grid.gridOptions"
          :grid-params.sync="tabSelling.grid.gridParams"
          :column-defs="dynamicColumnDefsForSelling"
          :sum-column-defs="apSumColumnDefs"
          config-module="130112"
          :row-data="tabSelling.grid.overseaSellingDetails"
          :cancel-sort-auto-reduce="false"
          style="flex-grow:1;margin-top:10px;padding-right: 10px;"
          min-height="100px"
          :show-row-groups="dataListDragGroup"
          :show-menu-items="!showMergeChargeItemSalesView"
          :pre-column-state-callback="preColumnStateCallback"
          @gridReady="onSellingGridReady"
          @columnRowGroupChanged="tabSelling.grid.groupColumns = $event;tabSelling.grid.groupRowNode = {}"
        />
        <cargo-ag-grid-wrapper
          v-show="showMergeChargeItemSalesView"
          ref="tabSellingGridMerge"
          no="130190"
          :grid-options="tabSellingMerge.grid.gridOptions"
          :grid-params.sync="tabSellingMerge.grid.gridParams"
          :column-defs="dynamicColumnDefsForSellingMerge"
          :sum-column-defs="apSumColumnDefs"
          config-module="130190"
          :row-data="tabSellingMerge.grid.overseaSellingDetails"
          :cancel-sort-auto-reduce="false"
          style="flex-grow:1;margin-top:10px;padding-right: 10px;"
          min-height="100px"
          :show-row-groups="dataListDragGroup"
          :show-menu-items="!showMergeChargeItemSalesView"
          :pre-column-state-callback="preColumnStateCallback"
          @gridReady="onSellingMergeGridReady"
          @columnRowGroupChanged="tabSellingMerge.grid.groupColumns = $event;tabSellingMerge.grid.groupRowNode = {}"
        />
      </template>
    </cargo-up-down-resize>
    <div v-if="!isBpm" class=" operations" style="margin-top: 10px">
      <div class="filters" />
      <div class="triggers">
        <div style="display: flex;flex-direction: column;width: 100%">
          <div style="display: flex;flex-direction: row;">

            <div>
              <span>{{ $t('CargoMsg.Cargo_Profit') }}</span>
              <charge-currency-total-group
                v-if="reCalc"
                no="profit"
                :amount-to-currency="localCurrency"
                :data-field="config._isCalculateExcludingAmount ? 'amount' : 'excludingTaxAmount' "
                rate-field="exchangeRate"
                :data-provider="revenueTotalGroup.dataProvider"
                :is-gross-profit="true"
                :show-controlled-profit="privilege.showControlledProfit"
                :show-controlled="privilege.isControlled"
                type="revenue"
                :show-cost-controlled="privilege.isCostControlled"
                source="chargeDetailAll"
              />
              <span v-if="config.showGrossProfit">{{ $t('CargoMsg.Cargo_GrossMargin') }}: </span>
              <charge-gross-margin
                v-if="config.showGrossProfit"
                :is-calculate-excluding-amount="config._isCalculateExcludingAmount"
                :data-provider="revenueTotalGroup.dataProvider"
              />
            </div>
            <template v-if="showEstimate">
              <span style="display: inline-block">({{ `${$t('FinanceManage.charge_estimate')}${estimateGrossProfit}` }})</span>
            </template>
            <div style="display: flex;flex-direction: row">
              <span style="color:#1890ff;width: 70px;">{{ $t('FinanceManage.charge_estimateRemarks') }}</span>
              <el-input v-model="job.situation" disabled />
            </div>
            <div v-show="privilege.showOtherBranchCharge" style="display: flex;flex-direction: row">
              <span style="margin-left:10px;margin-right:5px;font-weight:bold;">{{ this.$t('CargoMsg.Cargo_SettleBranchId') }}</span>
              <el-select
                v-model="settleBranchId"
                :placeholder="$t('SeaExport.PleaseSelect')"
                :clearable="false"
                size="mini"
                style="margin-right: 5px;width: 190px;"
                @change="p=>{ tabChargesHP.onSettleBranchIdHandler(p)}"
              >
                <el-option
                  v-for="(item,index) in officeList"
                  :key="index"
                  :label="item.chineseName"
                  :value="item.officeId"
                />
              </el-select>
            </div>
            <div style="margin-left: 10px">
              <el-checkbox
                v-show="checkbox.chkLcLCharge.visible=job.masterFlag"
                id="chkLcLCharge"
                v-model="checkbox.chkLcLCharge.selected"
                :label="$t('FinanceManage.charge_sp12')"
                :disabled="showMergeChargeItemSalesView"
                @change="tabChargesHP.chkLcLChargeHandler($event)"
              />
              <el-checkbox
                id="chkOffset"
                v-model="checkbox.chkOffset.selected"
                :label="$t('FinanceManage.charge_showRedCharges')"
                :disabled="showMergeChargeItemSalesView"
                @change="tabChargesHP.chkOffsetChargeHandler($event)"
              />
              <el-checkbox
                v-show="(checkbox.chkShowSharedCharge.visible=job && !job.masterFlag && !editing)"
                id="chkShowSharedCharge"
                v-model="checkbox.chkShowSharedCharge.selected"
                :label="$t('FinanceManage.charge_showSharedCharges')"
                @change="tabChargesHP.chkShowSharedChargeHandler($event)"
              />
              <!-- 显示普通费用 -->
              <el-checkbox
                v-show="checkbox.chkShowCommonCharge.visible=(privilege.showCommonCharge && !isFromFinanceModule)"
                id="chkShowCommonCharge"
                v-model="checkbox.chkShowCommonCharge.selected"
                :label="$t('FinanceManage.charge_showCommonCharge')"
                @change="tabChargesHP.chkShowCommonChargeHandler($event)"
              />
              <!-- 显示特殊费用 -->
              <el-checkbox
                v-show="checkbox.chkShowSpecialCharge.visible=(privilege.showSpecialCharge && !isFromFinanceModule)"
                id="chkShowSpecialCharge"
                v-model="checkbox.chkShowSpecialCharge.selected"
                :label="$t('FinanceManage.charge_showSpecialCharge')"
                @change="tabChargesHP.chkShowCommonChargeHandler($event)"
              />
              <!-- 显示商务特殊费用 -->
              <el-checkbox
                v-show="checkbox.chkShowBusinessSpecialCharge.visible=(privilege.showBusinessSpecialCharge && !isFromFinanceModule)"
                id="chkShowBusinessSpecialCharge"
                v-model="checkbox.chkShowBusinessSpecialCharge.selected"
                :label="$t('FinanceManage.charge_showBusinessSpecialCharge')"
                @change="tabChargesHP.chkShowCommonChargeHandler($event)"
              />
              <!-- 显示申请更改、删除费用 -->
              <el-checkbox
                v-show="false"
                id="chkShowChangeCharge"
                v-model="checkbox.chkShowChangeCharge.selected"
                :label="$t('CargoMsg.Cargo_DisplaysTheRequestChangeFee')"
                @change="tabChargesHP.chkShowChangeChargeHandler($event)"
              />
              <span v-if="pendingChargeSyncRecordNum > 0" style="color: red;cursor: pointer;" @click="tabChargesHP.showChargeSyncRecord()">
                <i style="text-decoration: underline">{{ pendingChargeSyncRecordNum }}</i>
                {{ $t('FinanceManage.synchronizationFeesToBeProcessed') }}
              </span>
              <span v-if="pendingChargeOutSyncRecordNum > 0" style="color: red;cursor: pointer;" @click="tabChargesHP.showChargeOutSyncRecord()">
                <i style="text-decoration: underline">{{ pendingChargeOutSyncRecordNum }}</i>
                {{ $t('SeaExport.SupplierFeesToBeProcessed') }}
              </span>
              <el-checkbox
                v-show="checkbox.chkInternal.visible"
                id="chkInternal"
                v-model="checkbox.chkInternal.selected"
                :label="$t('CargoMsg.Cargo_ShowInternalCharges')"
                @change="tabChargesHP.chkInternalChargeHandler($event)"
              />
              <el-checkbox
                v-show="!isAdjust && job.masterFlag && config.automaticAllocation && viewSource!=='salesDetail'"
                id="automaticAllocation"
                v-model="job.automaticAllocation"
                :label="$t('CargoMsg.Cargo_AutomaticAllocation')"
                :disabled="!(editing) || !settleBranchEnable"
              />
            </div>
            <div class="gp-explain">
              <span class="gp-explain-click" no="gpExplainClick" @click="gpExplain.visible = true;">{{ $t('FinanceManage.GpExplain') }}</span>
              <div v-if="gpExplain.gpExplainContent">
                <el-tooltip class="item" effect="dark" :content="gpExplain.gpExplainContent" placement="top-start">
                  <div class="gp-explain-ellipsis">{{ gpExplain.gpExplainContent }}</div>
                </el-tooltip>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 增加/删除/修改费用调整 -->
    <adjust-window
      :visible.sync="adjustWindow.visible"
      :default-properties="adjustWindow.defaultProperties"
      :view-source="isFromFinanceModule ? 'FinanceManage' : ''"
      :location="location"
      @returnCall="() => { tabChargesHP.clickHandler1Handler() }"
    />

    <!--  批量删除调整  -->
    <delete-adjust-dialog
      :visible.sync="batchDeleteAdjustWindow.visible"
      :charges="batchDeleteAdjustWindow.charges"
      :job="batchDeleteAdjustWindow.job"
      :is-ar="batchDeleteAdjustWindow.isAr"
      :location="location"
      @returnCall="() => { tabChargesHP.clickHandler1Handler() }"
    />

    <!-- 费用更正 -->
    <change-charge-dialog
      v-if="changeChargeDialog.visible"
      :visible.sync="changeChargeDialog.visible"
      :default-properties="changeChargeDialog.defaultProperties"
      :input-including-tax-unit-price="config.inputIncludingTaxUnitPrice"
      :show-wht-tax="showWhtTax"
      @close="changeChargeDialog.visible = false"
      @returnCall="() => { tabChargesHP.clickHandler1Handler() }"
    />
    <!-- 费用更正 -->
    <change-charge-work-flow-dialog
      ref="ccwDialog"
      :visible.sync="changeChargeWorkFlowDialog.visible"
      :job="changeChargeWorkFlowDialog.job"
      :privilege="changeChargeWorkFlowDialog.privilege"
      :params="changeChargeWorkFlowDialog.params"
      :config="config"
      :show-wht-tax="showWhtTax"
      :office-list="changeChargeWorkFlowDialog.officeList"
      @close="changeChargeWorkFlowDialog.visible = false"
      @returnCall="() => { tabChargesHP.clickHandler1Handler() }"
    />

    <!-- 改单费用调整 -->
    <change-charge-window
      :visible.sync="changeChargeWindow.visible"
      :default-properties="changeChargeWindow.defaultProperties"
      :apply-change-charge="changeChargeWindow.applyChangeCharge"
      :location="location"
      :customer-sales-display-star="changeChargeWindow.customerSalesDisplayStar"
      @returnCall="() => { tabChargesHP.clickHandler1Handler() }"
    />

    <!-- 特殊费用调整 -->
    <special-charge-window
      :visible.sync="specialChargeWindow.visible"
      :default-properties="specialChargeWindow.defaultProperties"
      :location="location"
      @returnCall="() => { tabChargesHP.clickHandler1Handler() }"
    />

    <!-- 商务特殊费用（独立弹窗，仅应付） -->
    <business-special-charge-window
      :visible.sync="businessSpecialChargeWindow.visible"
      :default-properties="businessSpecialChargeWindow.defaultProperties"
      :location="location"
      @returnCall="() => { tabChargesHP.clickHandler1Handler() }"
    />

    <!-- 费用方案导入弹窗 todo -->
    <charge-scheme-batch-dialog
      :visible.sync="chargePlanDialog.visible"
      :lob="chargePlanDialog.lob"
      :is-sea="chargePlanDialog.isSea"
      :original-condition="chargePlanDialog.originalCondition"
      :charge-scheme-is-approved="chargePlanDialog.chargeSchemeIsApproved"
      :source="chargePlanDialog.source"
      :job="job"
      :location="location"
      :sale-role-hide="saleRoleHide"
      @selectedSchemeHandler="(schemeDetails) => { tabChargesHP.selectedSchemeHandler(schemeDetails) }"
    />
    <!-- 抄录费用弹窗 -->
    <copy-charge-dialog
      :visible.sync="copyChargeDialog.visible"
      :lob="copyChargeDialog.lob"
      :is-sea="copyChargeDialog.isSea"
      :job="job"
      :view-source="viewSource"
      @selectedCopyChargeHandler="(chargeList) => { tabChargesHP.selectedCopyChargeHandler(chargeList) }"
    />
    <verified-dialog
      :visible="verifiedDialog.visible"
      :charge="verifiedDialog.charge"
      @cancel="verifiedDialog.visible = false"
    />
    <copy-slave-cost-dialog
      :visible="copySlaveCostDialog.visible"
      :params="copySlaveCostDialog.params"
      :uuid-prefix-rule="tabCost.grid.uuidPrefixRule"
      @success="copySlaveCostSuccessHandler"
      @cancel="copySlaveCostDialog.visible = false"
    />
    <!--运价表对话框-->
    <fcl-price-dialog
      v-if="isAllowedEdit && !isAdjust && editing"
      :visible="addPriceDialog.visible"
      :job="job"
      @close="addPriceDialog.visible = false"
      @itemSelected="onFCLSelected"
    />
    <!--运价表对话框-->
    <lcl-price-dialog
      v-if="isAllowedEdit && !isAdjust && editing"
      :visible="lclPriceDialog.visible"
      :job="job"
      @close="lclPriceDialog.visible = false"
      @itemSelected="onLCLSelected"
    />
    <!--费用分摊对话框-->
    <!-- <share-charge-dialog
      v-if="isAllowedEdit && job.masterFlag && !config.shareCharge"
      :visible.sync="shareChargeDialog.visible"
      :type="shareChargeDialog.type"
      :job="shareChargeDialog.job"
      :charge="shareChargeDialog.charge"
      :uuid-prefix-rule="tabCost.grid.uuidPrefixRule"
      @chargeShared="tabChargesHP.chargeSharedHandler()"
      @close="shareChargeDialog.visible = false"
    /> -->
    <!--新的费用分摊对话框-->
    <!-- <share-charge-dialog-new
      v-if="isAllowedEdit && job.masterFlag && config.shareCharge"
      :visible.sync="shareChargeDialog.visible"
      :type="shareChargeDialog.type"
      :job="shareChargeDialog.job"
      :charge="shareChargeDialog.charges && shareChargeDialog.charges.length > 0 ? shareChargeDialog.charges[0] : {}"
      :charges="shareChargeDialog.charges"
      :uuid-prefix-rule="tabCost.grid.uuidPrefixRule"
      @chargeShared="tabChargesHP.chargeSharedHandler()"
      @close="shareChargeDialog.visible = false"
    /> -->
    <!--费用分摊弹窗-->
    <charge-share-dialog
      v-if="isAllowedEdit && job.masterFlag"
      :visible.sync="shareChargeDialog.visible"
      :job="shareChargeDialog.job"
      :charges="shareChargeDialog.charges"
      :diff-charge-keys="shareChargeDialog.diffChargeKeys"
      :location="location"
      @chargeShared="tabChargesHP.chargeSharedHandler()"
    />

    <!-- 选择结算对象弹窗 -->
    <settlement-select-dialog :visible.sync="settlementSelectDialog.visible" :title="settlementSelectDialog.title" :accounts="settlementSelectDialog.accounts" :source="'tabCharges'" @selectItemWinHandler="selectItemWinHandler" />

    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />

    <!-- 预估利润率验证弹窗-->
    <estimate-validation-dialog
      ref="estimateValidationDialog"
      :visible.sync="estimateValidationDialog.visible"
      :job="estimateValidationDialog.job"
      :estimate-profit-rate="estimateValidationDialog.estimateProfitRate"
      :tatol-profit="estimateValidationDialog.tatolProfit"
      :editable="estimateValidationDialog.editable"
      @callback="estimateValidationDialog.callback"
    />

    <!--费用同步记录弹窗-->
    <charge-sync-record-dialog
      v-if="showChargeSyncRecord"
      :visible.sync="chargeSyncRecordDialog.visible"
      :job="chargeSyncRecordDialog.job"
      :charge-sync-check-job-state="config.chargeSyncCheckJobState"
      :location="location"
      @callback="chargeSyncConfirmCallback"
    />

    <!--外部推送费用同步记录弹窗-->
    <charge-out-sync-record-dialog
      :visible.sync="chargeOutSyncRecordDialog.visible"
      :job="chargeOutSyncRecordDialog.job"
      :charge-sync-check-job-state="config.chargeSyncCheckJobState"
      :location="location"
      @callback="chargeOutSyncConfirmCallback"
    />

    <!-- 销售新增费用 -->
    <add-charge-dialog
      v-if="addChargeDialog.visible"
      :visible.sync="addChargeDialog.visible"
      :input-including-tax-unit-price="config.inputIncludingTaxUnitPrice"
      :default-properties="addChargeDialog.defaultProperties"
      :location="location"
      :config="config"
      @close="addChargeDialog.visible = false"
      @returnCall="() => { tabChargesHP.clickHandler1Handler() }"
    />

    <!-- 申请更改中的费用 -->
    <changing-charge-detail-dialog
      v-if="changingChargeDetailDialog.visible"
      :visible="changingChargeDetailDialog.visible"
      :job-uuid="job.uuid"
      @onCancel="changingChargeDetailDialog.visible = false"
    />

    <!-- 修改费用到期日 -->
    <update-due-date-dialog
      v-if="updateDueDateDialogDialog.visible"
      :visible.sync="updateDueDateDialogDialog.visible"
      @returnCall="(dueDate) => { tabChargesHP.confirmUpdateDueDate(dueDate) }"
    />

    <!-- 修改费用备注 -->
    <update-remark-dialog
      v-if="updateRemarkDialog.visible"
      :visible.sync="updateRemarkDialog.visible"
      @returnCall="(remark) => { tabChargesHP.confirmUpdateRemark(remark) }"
    />

    <!-- 修改结算对象弹窗 -->
    <change-account-id-dialog
      v-if="changeAccountIdDialog.visible"
      :visible.sync="changeAccountIdDialog.visible"
      :is-ar="changeAccountIdDialog.isAr"
      :company-factory-signs="changeAccountIdDialog.companyFactorySigns"
      @changeAccountId="(p) => { tabChargesHP.changeAccountCallBack(p) }"
    />
    <!-- 更改前后对比弹窗 -->
    <before-and-after-comparison-dialog-bpm
      v-if="beforeAndAfterComparisonDialogBpm.visible"
      :visible.sync="beforeAndAfterComparisonDialogBpm.visible"
      :change-reason="beforeAndAfterComparisonDialogBpm.changeReason"
      :ar-charge-before="beforeAndAfterComparisonDialogBpm.arChargeBefore"
      :ap-charge-before="beforeAndAfterComparisonDialogBpm.apChargeBefore"
      :ar-charge-after="beforeAndAfterComparisonDialogBpm.arChargeAfter"
      :ap-charge-after="beforeAndAfterComparisonDialogBpm.apChargeAfter"
      :charge-original-profit="beforeAndAfterComparisonDialogBpm.chargeOriginalProfit"
      :charge-change-profit="beforeAndAfterComparisonDialogBpm.chargeChangeProfit"
      :ap-tip="beforeAndAfterComparisonDialogBpm.apTip"
      :ar-tip="beforeAndAfterComparisonDialogBpm.arTip"
      @onCancel="() => { beforeAndAfterComparisonDialogBpm.visible = false }"
    />

    <!-- GP说明-->
    <add-gp-explain-dialog
      v-if="gpExplain.visible"
      :type="gpExplain.type"
      :visible.sync="gpExplain.visible"
      :job-uuids="[job.uuid]"
      @callback="getGpExplainRecordByJobUuid"
    />
    <!-- 对账差异处理 -->
    <reconciliation-diff-confirm-dialog
      v-if="reconciliationDiffDialog.visible"
      :visible.sync="reconciliationDiffDialog.visible"
      @returnCall="(reason) => { tabChargesHP.confirmReconciliationDiff(reason) }"
    />
  </div>
</template>

<script>

import { formatNumberToThousands } from '@/utils'
import cargoUpDownResize from '@/components/Cargo/Common/cargoUpDownResize'
import fclPriceDialog from '@/components/Cargo/Job/fclPriceDialog'
// import shareChargeDialog from '@/components/Cargo/Job/shareChargeDialog'
import ChargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog'
import CopyChargeDialog from '@/views/cargo/v0/SeaExport/components/booking/copyChargeDialog'
import VerifiedDialog from '@/views/cargo/v0/SeaExport/components/booking/verifiedDialog'
import CopySlaveCostDialog from '@/views/cargo/v0/SeaExport/components/booking/copySlaveCostDialog'
import adjustWindow from '@/components/Cargo/Job/adjustWindow'
import changeChargeWindow from '@/components/Cargo/Job/changeChargeWindow'
import specialChargeWindow from '@/components/Cargo/Job/specialChargeWindow'
import businessSpecialChargeWindow from '@/components/Cargo/Job/businessSpecialChargeWindow'
import TabChargesHP from './tabChargesHP'
import * as NumberUtils from '@/utils/NumberUtils'
import { Job } from '@/class/model/booking/Job'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import lodash from 'lodash'
import LclPriceDialog from '@/components/Cargo/Job/lclPriceDialog'
import { Once, MarkManage, catchErrorTip, ensureExecuteSuccess } from '@/utils/commonUtil'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import settlementSelectDialog from '@/components/Cargo/Job/settlementSelectDialog'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import EstimateValidationDialog from '@/components/Cargo/Job/estimateValidationDialog'
import CargoButtonGroupSlider from '@/components/Cargo/Common/CargoButtonGroupSlider'
import ChangeAccountIdDialog from '@/components/Cargo/Job/changeAccountIdDialog'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import CargoAgGridAdvanceMultipleSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceMultipleSelectEditor/index'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import ChargeGrossMargin from '@/components/Cargo/Act/chargeSummary/ChargeGrossMargin'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
// import ShareChargeDialogNew from '@/components/Cargo/Job/shareChargeDialogNew'
import chargeShareDialog from '@/components/Cargo/Job/chargeShareDialog'
import ChangeChargeDialog from '@/components/Cargo/Job/changeChargeDialog'
import ChangeChargeWorkFlowDialog from '@/components/Cargo/Job/changeChargeWorkFlowDialog'
import chargeSyncRecordDialog from '@/components/Cargo/Job/chargeSyncRecordDialog'
import chargeOutSyncRecordDialog from '@/components/Cargo/Job/chargeOutSyncRecordDialog'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import { getCacheListByKey, getObjectByCache, operateBranchIsOptional, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import AddChargeDialog from '@/views/cargo/v0/Sales/components/salesQuery/tabs/addChargeDialog'
import ChangingChargeDetailDialog from '@/components/Cargo/Job/changingChargeDetailDialog'
import UpdateDueDateDialog from '@/components/Cargo/Job/updateDueDateDialog'
import { getCreditConfig } from '@/api/sysManage/creditConfig'
import { cache, cacheName } from '@/utils/cacheManager'
import beforeAndAfterComparisonDialogBpm from '@/views/cargo/v0/Clearing/components/ChangeChargeVerify/beforeAndAfterComparisonDialogBpm'

import AddGpExplainDialog from '@/components/Cargo/Job/addGpExplainDialog.vue'
import { queryGpExplainRecord } from '@/api/booking/gpExplainRecord'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import UpdateRemarkDialog from '@/components/Cargo/Job/updateRemarkDialog'
import cargoAgGridWrapper from '@/components/Cargo/Common/cargoAgGridWrapper'
import DeleteAdjustDialog from '@/views/cargo/v0/Clearing/components/financeManage/deleteAdjustDialog'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { getCustomerByRole } from '@/api/booking/job'
import reconciliationDiffConfirmDialog from '@/components/Cargo/Job/reconciliationDiffConfirmDialog'
import { v4 as uuidv4 } from 'uuid'

export default {
  name: 'TabCharges',
  components: {
    DeleteAdjustDialog,
    UpdateDueDateDialog,
    ChangingChargeDetailDialog,
    AddChargeDialog,
    ChangeChargeDialog, ChargeGrossMargin, CargoButtonGroupSlider, EstimateValidationDialog, LclPriceDialog, settlementSelectDialog, ChargeCurrencyTotalGroup, cargoUpDownResize,
    // ShareChargeDialogNew, shareChargeDialog,
    ChangeAccountIdDialog, UpdateRemarkDialog,
    ChargeSchemeBatchDialog, CopyChargeDialog, adjustWindow, VerifiedDialog, CopySlaveCostDialog, fclPriceDialog, changeChargeWindow, specialChargeWindow, businessSpecialChargeWindow, cargoTemplateSelectorDialog,
    CargoAgGridSelectEditor, chargeSyncRecordDialog, chargeShareDialog, chargeOutSyncRecordDialog, ChangeChargeWorkFlowDialog, beforeAndAfterComparisonDialogBpm, AddGpExplainDialog,
    cargoAgGridWrapper, reconciliationDiffConfirmDialog
  },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: { type: String, required: true },
    isAmended: { type: Boolean, default: false }, // 是否对账
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    isFromFinance: { // 来源于财务模块
      type: Boolean,
      default: false
    },
    isCrossTenantSeToSi: { // 是否跨租户出口转进口
      type: Boolean,
      required: false
    },
    chargeSource: { type: Number, default: 0 }, // 费用来源
    adjust: { type: Boolean, default: false }, // 是否财务审核进入费用页面
    isBpm: { // 是否显示操作
      type: Boolean,
      default: false
    },
    location: { type: String, required: false },
    saleRoleHide: { type: Boolean, default: false }, // 子应用销售角色
    customerSalesDisplay: { type: Boolean, default: false }, // 子应用销售角色可选结算对象范围外的显示
    tabName: { type: String, default: 'tabCharges' },
    type: { type: String, default: '' }, // 应收:ar, 应付:ap
    enableUiCustom: { type: Boolean, required: false }, // 是否启用UI自定义
    provisionLock: {
      type: Object,
      default: () => ({ etdLocked: false, feeLocked: false })
    }
  },
  data() {
    return {
      localCurrency: 'RMB',
      reCalc: true,
      loading: false,
      tabChargesHP: new TabChargesHP(this),
      once: null,
      // live AR/AP grid selection counts — create buttons bind disabled to arSelectedCount/apSelectedCount > 0.
      arSelectedCount: 0,
      apSelectedCount: 0,
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        companyContactPersonMap: new Map(), // company对应的联系人map 缓存
        companyCmpIdxForCustomerMap: new Map(), // 结算单位
        chargeMeasureSet: new Set(), // 费用单位
        mblCargoDocSet: new Set(), // 关单号set
        hblCargoDocSet: new Set(), // 关单号set
        officeIdForDepartmentMap: new Map(),
        officeIdForClearDepartmentMap: new Map(), // 结算公司
        currencySet: new Set(),
        userAllSet: new Set(), // cache中取得全部用户集合
        containerNoAllSet: new Set(), // 全部箱号
        user4AuditorSet: new Set(), // 审核人数据集合
        paymentTermSet: new Set(),
        customerDefaultTitleMap: new Map(), // 委托单位和默认发票抬头
        customerTitlesMap: new Map(), // 委托单位和关联的发票抬头
        customerSettlementAgentMap: new Map(), // 结算对象关联的结算代理
        chargeItemSet: new Set() // 收费项目
      },
      estimateValidationDialog: {
        visible: false,
        job: { estimateAccountsReceivable: 0, estimateAccountsPayable: 0, estimateGrossProfit: 0, situation: '' },
        estimateProfitRate: 0,
        editable: false,
        tatolProfit: 0,
        callback: () => {}
      },
      changingChargeDetailDialog: {
        visible: false
      },
      identifierType: '',
      job: new Job().fillDefaultValue().getData(),
      companyTitle: null, // Company关联发票抬头、中间变量
      isAuditOpr: false, // 是否是审核操作
      jobControlledCharges: [], //  包含受控费用
      isSelChargeReceivabel: false,
      departmentTeamUser: [], // 同部门的人
      isNotAmended: !this.isAmended, // 是否对账
      isAllowedEdit: true, // 操作通常允许文件上传与删除，销售只允许查看，不能编辑。
      isAllCostControlled: false, //  勾选的应收费用是否全部受控  true-全部为受控费用（此时应收的受控按钮显示"取消受控"）;其他情况一律为false(此copyedChargeList时应收的受控按钮显示"受控")
      isAllSellingControlled: false, // 勾选的应付费用是否全部受控  true-全部为受控费用（此时应付的受控按钮显示"取消受控"）;其他情况一律为false(此时应付的受控按钮显示"受控")
      showInviteChargeConfirm: false, // 是否显示[邀请确认费用]按钮
      batchAmendmentFee: false, // 业务菜单费用页签是否批量申请修改操作
      isAdjust: this.adjust,
      btnEditing: true, // 按钮是否能编辑
      costCharge: null, // 应收临时行对象
      needLoadDeptUser: false, // 是否加载同组人员
      copyedChargeList: [], // 被抄录的费用
      companyFactorySigns: [], // 委托单位和关联的工厂
      arTotalGroup: {
        dataProvider: [],
        visible: false
      },
      apTotalGroup: {
        dataProvider: [],
        visible: false
      },
      revenueTotalGroup: {
        dataProvider: [],
        visible: false
      },
      checkbox: {
        chkShowCommonCharge: {
          visible: false,
          selected: false
        },
        chkShowSpecialCharge: {
          visible: false,
          selected: false
        },
        chkShowBusinessSpecialCharge: {
          visible: false,
          selected: false
        },
        chkLcLCharge: {
          visible: false,
          selected: false
        },
        chkOffset: {
          visible: false,
          selected: false
        },
        chkShowSharedCharge: {
          visible: false,
          selected: false
        },
        chkShowChangeCharge: {
          visible: false,
          selected: false
        },
        chkInternal: { // 内结费用
          visible: false,
          selected: true // 默认勾选
        }
      },
      btn: {
        addCostSpecialOSButton: {
          enabled: true
        },
        addCostSpecialOCButton: {
          enabled: true
        },
        addCostBusinessSpecialButton: {
          enabled: true
        }
      },
      arChargeSyncBtns: [],
      arChargeSyncCommand: '',
      arChargeSyncEnabled: false,
      privilege: {
        showSpecialCharge: false,
        showCommonCharge: false,
        addChange: false,
        editSpecialCharge: false, // 编辑特殊费用
        addSpecialCharge: false, // 添加特殊费用
        addSpecialUpdate: false, // 添加特殊费用
        showBusinessSpecialCharge: false, // 查看商务特殊费用（任一范围权限即可见，海创个性化开启时初始化）
        editBusinessSpecialCharge: false, // 编辑商务特殊费用
        addBusinessSpecialCharge: false, // 新增商务特殊费用
        isControlled: this.$checkPermission(['button_Charge_controlled']), // 是否有应付受控费用权限
        isCostControlled: this.$checkPermission(['button_Charge_costControlled']), // 是否有应收受控费用权限
        isSubmitChargeRole: this.$checkPermission(['button_Charge_submitCharge']), // 提交费用权限
        isCancelSubmitChargeRole: this.$checkPermission(['button_Charge_cancelSubmitCharge']), // 取消提交费用权限
        isInviteChargeConfirm: this.$checkPermission(['button_Charge_inviteChargeConfirm']), // 是否具有邀请确认费用的权限
        isAdjustmentAddRole: this.$checkPermission(['button_Charge_addAdjustment']), // 增加调整权限
        isAdjustmentAddRolePositiveNum: this.$checkPermission(['button_Charge_addAdjustmentPositiveNum']), // 增加调整权限（仅可增加正数费用）
        isAdjustmentEditRole: this.$checkPermission(['button_Charge_editAdjustment']), // 修改调整权限
        isAdjustmentDeleteRole: this.$checkPermission(['button_Charge_deleteAdjustment']), // 删除调整权限
        isCostAddChargeRole: this.$checkPermission(['button_Charge_costAddCharge']), // 应收费用新增权限
        isPayAddChargeRole: this.$checkPermission(['button_Charge_payAddCharge']), // 应付费用新增权限
        copyCharge: this.$checkPermission(['role_Charge_copyCharge']), // 抄录费用
        userChargeRole: true,
        branchChargeRole: true,
        departmentChargeRole: true,
        editArDeptCharge: this.$checkPermission(['role_Charge_editArDeptCharge']), // 应收编辑同组费用
        editArAllCharge: this.$checkPermission(['role_Charge_editArAllCharge']), // 应收编辑所有费用
        editPersonalArCharge: this.$checkPermission(['role_Charge_editPersonalArCharge']), // 应收编辑个人费用
        editApDeptCharge: this.$checkPermission(['role_Charge_editApDeptCharge']), // 应付编辑同组费用
        editApAllCharge: this.$checkPermission(['role_Charge_editApAllCharge']), // 应付编辑所有费用
        editPersonalApCharge: this.$checkPermission(['role_Charge_editPersonalApCharge']), // 应付编辑个人费用
        deleteArDeptCharge: this.$checkPermission(['role_Charge_deleteArDeptCharge']), // 应收删除同组费用
        deleteArAllCharge: this.$checkPermission(['role_Charge_deleteArAllCharge']), // 应收删除所有费用
        deleteApDeptCharge: this.$checkPermission(['role_Charge_deleteApDeptCharge']), // 应付删除同组费用
        deleteApAllCharge: this.$checkPermission(['role_Charge_deleteApAllCharge']), // 应付删除所有费用
        deletePersonalArCharge: this.$checkPermission(['role_Charge_deletePersonalArCharge']), // 应收删除个人费用
        deletePersonalApCharge: this.$checkPermission(['role_Charge_deletePersonalApCharge']), // 应付删除个人费用
        copyReceivable: this.$checkPermission(['role_Charge_copyReceivable']), // 抄录应收
        copyPayable: this.$checkPermission(['role_Charge_copyPayable']), // 抄录应付
        chargeProject: this.$checkPermission(['role_Charge_chargeProject']), // 费用方案(费用页签)
        applyAddCharge: this.$checkPermission(['button_Charge_applyAddCharge']), // 申请新增费用
        applyChangeCharge: this.$checkPermission(['button_Charge_applyChangeCharge']), // 申请更改费用
        applyDeleteCharge: this.$checkPermission(['button_Charge_applyDeleteCharge']), // 申请删除费用
        showApplyChangingCharge: this.$checkPermission(['button_Charge_showApplyChangingCharge']), // 申请更改中的费用
        generateChargeByContractNo: this.$checkPermission(['button_Charge_generateByContract']), // 通过约号带入费用
        updateRemarkCharge: this.$checkPermission(['button_Charge_updateRemark']), // 追加备注权限
        reconciliationDiffAr: this.$checkPermission(['button_Charge_reconciliationDiffAr']), // 对账差异处理权限
        reconciliationDiffAp: this.$checkPermission(['button_Charge_reconciliationDiffAp']),
        chargeAuditFlow: false, // 2555 环海费用配置
        showControlledProfit: false, // 是否显示受控费用利润
        enableCommission: false, // 显示普通费用
        queryArAllRole: true, // 应收查看所有费用
        queryArDeptChargeRole: true, //  应收查看同组费用
        queryArUserChargeRole: true, // 应收查看自己费用
        queryApAllRole: true, // 应付查看所有费用
        queryApDeptChargeRole: true, //  应付查看同组费用
        queryApUserChargeRole: true, // 应付查看自己费用
        isSalesCostAddChargeRole: this.$checkPermission(['button_SalesQueryModule_salesAddCostCharge']), // 销售应收费用新增权限
        isSalesPayAddChargeRole: this.$checkPermission(['button_SalesQueryModule_salesAddPayCharge']), // 销售应付费用新增权限
        isSalesCostEditChargeRole: this.$checkPermission(['button_SalesQueryModule_salesEditCostCharge']), // 销售应收费用编辑权限
        isSalesPayEditChargeRole: this.$checkPermission(['button_SalesQueryModule_salesEditPayCharge']), // 销售应付费用编辑权限
        salesDeleteArDeptCharge: this.$checkPermission(['button_SalesQueryModule_salesDeleteCostCharge']), // 销售应收删除费用
        salesDeleteApDeptCharge: this.$checkPermission(['button_SalesQueryModule_salesDeletePayCharge']), // 销售应付删除费用
        salesChargePayable: this.$checkPermission(['button_SalesQueryModule_salesChargePayable']), // 销售查询-费用方案
        showOtherBranchCharge: operateBranchIsOptional() ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['button_Charge_showOtherBranchCharge'])), // 查看结算公司是其他协作分公司的费用
        modifyOtherBranchCharge: operateBranchIsOptional() ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['button_Charge_modifyOtherBranchCharge'])), // 增删改结算公司是其他协作分公司的费用
        showAllCooperateCharge: operateBranchIsOptional() ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['role_Charge_showAllCooperateCharge'])), // 查看所有协作公司费用(ALL)
        modifyOtherBranchCharge2ProfitShare: operateBranchIsOptional() ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['button_Charge_modifyOtherBranchCharge2ProfitShare'])), // 当参与分润时可增删改所有分公司费用
        showAllCooperateCharge2ProfitShare: operateBranchIsOptional() ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['role_Charge_showAllCooperateCharge2ProfitShare'])) // 当参与分润时可查看所有分公司费用
      },
      config: {
        isInputZeroFee: false,
        isMergeChargeItemSalesView: false,
        showLCLCharges: false,
        showSharedCharges: false,
        isCommittedAllowAddCost: false,
        _isCalculateExcludingAmount: false, // 收入、成本、利润用含税价计算还是不含税价
        _getHBLcWeight: false, // 应收计费重量是否取分单的计费重量
        requireEstimate: false,
        isBookingFeeMandatoryAppliedGlobally: false, // 订舱费用必填是否全模块应用
        isChargeSubmitDirect: false, // 是否直接提交审核费用
        canUpdateExchangeRate: false, // 是否可直接修改汇率
        isInputChargeBaseOnService: false, // 是否按服务项目录入费用
        isVerifyChargeServiceType: false, // 订舱录入费用是否验证服务项目
        copySlaveCostToMasterCharge: false, // 抄录小票成本到主票应收
        chargeCommitAll: false, // 应收应付统一提交或取消
        openSapConfig: false, // 是否开启sap交单
        chargeModifyType: 0, // 费用调整模式
        chkShowCommonChargeSelected: false, // 是否勾选显示普通费用
        chkShowSpecialChargeSelected: false, // 是否勾选显示特殊费用
        chkShowBusinessSpecialChargeSelected: true, // 是否勾选显示商务特殊费用
        inputIncludingTaxUnitPrice: 0, // 单价是否含税
        openMutualTrustConfig: 0, // 是否开启费用交叉委托
        enableEntrustmentSI: false, // 是否海出委托转海进演示
        consignationImportByAE: false, // 是否空运出口转进口
        applyChangeChargeButton: false, // 是否申请更改费用按钮
        contractBinding: false, // 是否带入约价按钮
        // shareCharge: false, // 分摊费用是否使用新页面
        openHecConfig: false, // 是否开启合创交单
        toExoSystemEAS: false, // EAS费用同步
        toExoSystemLHEAS: false, // 隆和EAS
        toExoSystemYGSH: false, // 阳光速航
        toExoSystemHC: false, // 海创
        showGrossProfit: true, // 是否显示毛利率,默认显示【1:显示，0:不显示】
        chargeSyncNeedConfirm: false, // 出口进口费用同步，是否需要确认
        chargeSyncCheckJobState: null, // 费用同步校验双方业务状态（前置条件，需要启用参数ChargeSyncNeedConfirm）
        showCommissionAmount: false, // 是否显示提成金额
        accountObjectControlMode: false, // 结算单位控制模式
        currentOfficeCharge: false, // 是否开启选择不同操作公司后费用结算公司为当前分公司
        jinRongExchangeMode: false, // 锦荣交单模式
        arSettlementUnitOptional: false, // 新增应收结算单位可选范围配置项
        modificationFeeDueDate: false, // 手动修改费用到期日
        isReceivedChargeApiAllowedEdit: false, // 是否允许编辑通过费用推送接口新增的费用
        isSpecialExpenseEntryFunction: false,
        currencyChangeBySettlementAccount: 2, // 费用币种根据结算对象联动修改逻辑（0=修改结算对象不影响币种，1=仅首次填写结算对象时修改币种；2=修改结算对象总是判断重新修改币种。
        automaticAllocation: false // 是否主单费用自动分摊到小票
      },
      tabTotal: {
        visible: true
      },
      tabCost: { // 应收
        visible: true,
        grid: {
          uuidPrefixRule: 'addTabCost__', // 临时新增的uuid规则
          deleteUuids: [],
          modifyUuids: [],
          selectedRow: null, // 当前选中行， 待处理
          gridApi: null,
          chooseUuidSet: new Set(),
          chooseUuid: '',
          overseaCostDetails: [],
          columnDefs: [{
            headerName: this.$t('SeaExport.CustomerSpecialRequirements'),
            field: '',
            width: 300
          }],
          gridOptions: {

          },
          gridParams: {},
          groupColumns: {},
          groupRowNode: {}
        }
      },
      tabSelling: { // 应付
        visible: true,
        grid: {
          uuidPrefixRule: 'addTabSelling__', // 临时新增的uuid规则-待测试
          deleteUuids: [],
          modifyUuids: [],
          selectedRow: null,
          gridApi: null,
          chooseUuidSet: new Set(),
          columnDefs: [],
          gridOptions: {
          },
          gridParams: {},
          overseaSellingDetails: [],
          groupColumns: {},
          groupRowNode: {}
        }
      },
      tabSellingMerge: { // 应付合并
        visible: true,
        grid: {
          selectedRow: null,
          gridApi: null,
          chooseUuidSet: new Set(),
          columnDefs: [],
          gridOptions: {
          },
          gridParams: {},
          overseaSellingDetails: [],
          groupColumns: {},
          groupRowNode: {}
        }
      },
      pendingChargeSyncRecordNum: 0, // 待处理的费用同步记录条数
      pendingChargeOutSyncRecordNum: 0, // 待处理的外部推送费用同步记录条数
      adjustWindow: {
        visible: false,
        defaultProperties: {} // 费用调整默认条件
      },
      batchDeleteAdjustWindow: {
        visible: false,
        charges: [],
        job: {},
        isAr: false
      },
      changeChargeWindow: {
        visible: false,
        companyFactorySigns: [],
        defaultProperties: {}, // 改单费用调整默认条件
        applyChangeCharge: false, // 是否申请更改费用
        customerSalesDisplayStar: false // 销售查询-修改应收费用：结算对象：不允许修改、以*号显示
      },
      changeChargeDialog: { // 费用更改
        visible: false,
        defaultProperties: {}, // 改单费用调整默认条件
        applyChangeCharge: false // 是否申请更改费用
      },
      changeChargeWorkFlowDialog: { // 费用更改
        visible: false,
        job: {},
        privilege: {},
        params: {},
        officeList: [] // 结算公司
      },
      addChargeDialog: { // 销售新增费用
        visible: false,
        defaultProperties: {} // 默认条件
      },
      specialChargeWindow: {
        visible: false,
        defaultProperties: {} // 特殊费用调整默认条件
      },
      businessSpecialChargeWindow: {
        visible: false,
        defaultProperties: {} // 商务特殊费用默认条件
      },
      chargePlanDialog: {
        visible: false,
        selectedJobs: [],
        originalCondition: {},
        isSea: false,
        lob: 'SE',
        source: 'tabCharges',
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      copyChargeDialog: {
        visible: false,
        selectedJobs: [],
        isSea: false,
        lob: 'SE'
      },
      verifiedDialog: {
        visible: false,
        charge: {}
      },
      copySlaveCostDialog: {
        visible: false,
        params: {}
      },
      addPriceDialog: {
        visible: false
      },
      lclPriceDialog: {
        visible: false
      },
      shareChargeDialog: {
        visible: false,
        // type: 'cost',
        job: {},
        charges: [],
        // charge: {},
        diffChargeKeys: []
      },
      settlementSelectDialog: {
        visible: false,
        type: '', // 区分是哪个功能调用了这个窗口（print / eas）
        receivable: false, // 区分应收应付
        title: '',
        accounts: []
      },
      changeAccountIdDialog: {
        isAr: false,
        companyFactorySigns: [],
        visible: false
      },
      tempCharges: [], // 费用同步临时存储费用对象
      templateSelectorDialog: {// 模板选择弹窗
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      chargeSyncRecordDialog: {
        visible: false,
        job: {}
      },
      chargeOutSyncRecordDialog: {
        visible: false,
        job: {}
      },
      isCostRowDragEnd: false,
      oldCostSort: [],
      isSellingRowDragEnd: false,
      oldSellingSort: [],
      oldSellingMergeSort: [],
      columnState: [],
      markManage: new MarkManage(),
      chargeChangeStateMap: null, // 费用更正申请进度
      creditInfoVOMap: null, // 信控相关
      settleBranchId: 0, // 结算公司Id
      officeList: [],
      addCostEventFlag: false, // 新增(应收)事件标识
      addSellingEventFlag: false, // 新增(应付)事件标识
      customerSalesCmpList: null, // 结算对象根据销售权限获取到下拉数据,
      updateDueDateDialogDialog: {
        visible: false,
        receivable: false
      },
      updateRemarkDialog: {
        visible: false,
        receivable: false
      },
      receiptCharges: [], // 要更新的小票费用
      creditConfig: {},
      arAuxiliaryDataMap: new Map(),
      apAuxiliaryDataMap: new Map(),
      // 更改前后对比
      beforeAndAfterComparisonDialogBpm: {
        visible: false,
        apTip: '',
        arTip: '',
        changeReason: '', // 更改原因
        arChargeBefore: [], // 修改前
        apChargeBefore: [], // 修改前
        arChargeAfter: [], // 修改后,
        apChargeAfter: [], // 修改后,
        chargeOriginalProfit: [], // 整票预估利润：修改前
        chargeChangeProfit: [] // 整票预估利润：修改后
      },
      gpExplain: {
        type: 'detail',
        gpExplainContent: '',
        visible: false,
        jobUuids: []
      },
      isExcludedOffice: false,
      dataListDragGroup: false, // 是否支持数据列表拖拽分组特性
      arSumColumnDefs: [],
      apSumColumnDefs: [],
      seArElementDict: {},
      seApElementDict: {},
      aeArElementDict: {},
      aeApElementDict: {},
      reconciliationDiffDialog: { // 对账差异处理
        visible: false,
        receivable: false,
        chargeKeys: []
      }
    }
  },
  computed: {
    // 计提校准锁定新增应收应付
    provisionFeeLocked() {
      return !!(this.provisionLock && this.provisionLock.feeLocked)
    },
    lockArWithProvision() {
      return this.lockAr || this.provisionFeeLocked
    },
    lockApWithProvision() {
      return this.lockAp || this.provisionFeeLocked
    },

    // 列状态预处理：有显示销售单价hc权限时强制隐藏核销金额、未销金额，防止localStorage缓存覆盖
    preColumnStateCallback() {
      return columnState => {
        if (this.tabChargesHP._view.privilege.showSalePriceHc) {
          columnState.forEach(state => {
            if (state.colId === 'verifiedAmount' || state.colId === 'chargeUnverifiedAmount') {
              state.hide = true
            }
          })
        }
        return columnState
      }
    },

    // 是否显示应收结算费用按钮
    showArChargeAuditButton() {
      return this.privilege.editPersonalArCharge ||
        this.privilege.editArDeptCharge ||
        this.privilege.editArAllCharge
    },
    // 是否显示应付结算费用按钮
    showApChargeAuditButton() {
      return this.privilege.editPersonalApCharge ||
        this.privilege.editApAllCharge ||
        this.privilege.editApDeptCharge
    },
    showMergeChargeItemSalesView() { // CARGO-46041 新增费用合并逻辑【远程订舱、销售查询】
      return this.config.isMergeChargeItemSalesView && ['RemoteBooking', 'salesDetail'].includes(this.viewSource)
    },
    isFromFinanceModule() { //  CARGO-2239，财务审核-费用：是否根据[当前分公司]来过滤[费用所属分公司]：false=从[业务详情]的不过滤;true=从[财务审核]要过滤
      return this.isFromFinance
    },
    language() {
      return this.$store.getters.language === 'zh'
    },
    editing() {
      return this.action !== 'look'
    },
    isOtherEdit() {
      return this.action === 'split' || this.action === 'copy' // 复制/拆分主票
    },
    dynamicColumnDefsForSelling() {
      // console.log('dynamicColumnDefsForSelling=====')
      let result = this.tabChargesHP.getDynamicColumnDefsForSelling()
      if (this.showWhtTax) {
        result.push(...this.tabChargesHP.getWhtColumnDefsForSelling())
      }
      if (this.$store.state.uiCustom.enable && this.enableUiCustom) {
        result = UICustomUtil.handleColumnLabelAndDisplay(result, this.apElementDict)
      }
      if (this.editing) {
        for (const data of result) {
          data.sortable = false
        }
      }
      return result
    },
    dynamicColumnDefsForSellingMerge() {
      const result = this.tabChargesHP.getDynamicColumnDefsForSellingMerge()
      if (this.editing) {
        for (const data of result) {
          data.sortable = false
        }
      }
      return result
    },
    dynamicColumnDefsForCost() {
      // console.log('dynamicColumnDefsForCost=====')
      let result = this.tabChargesHP.getDynamicColumnDefsForCost()
      if (this.showWhtTax) {
        result.push(...this.tabChargesHP.getWhtColumnDefsForCost())
      }
      if (this.$store.state.uiCustom.enable && this.enableUiCustom) {
        result = UICustomUtil.handleColumnLabelAndDisplay(result, this.arElementDict)
      }
      if (this.editing) {
        for (const data of result) {
          data.sortable = false
        }
      }
      return result
    },
    estimateAccountsReceivable() {
      return formatNumberToThousands(NumberUtils.formatNumber(this.job.estimateAccountsReceivable, 2), 2)
    },
    estimateGrossProfit() {
      return formatNumberToThousands(NumberUtils.formatNumber(this.job.estimateGrossProfit, 2), 2)
    },
    estimateAccountsPayable() {
      return formatNumberToThousands(NumberUtils.formatNumber(this.job.estimateAccountsPayable, 2), 2)
    },
    canShareCost() {
      return this.tabCost.grid.selectedRow != null && !this.editing && this.tabChargesHP.shareEnableNew(this.tabCost.grid.selectedRow, this.adjust)
    },
    canShareSelling() {
      return this.tabSelling.grid.selectedRow != null && !this.editing && this.tabChargesHP.shareEnableNew(this.tabSelling.grid.selectedRow, this.adjust)
    },
    chooseChargeUuids() {
      return [...this.tabCost.grid.chooseUuidSet, ...this.tabSelling.grid.chooseUuidSet]
    },
    lockAr() { // 是否锁定应收费用
      return this.job && this.job.receivableChargeLockedStatus === 1
    },
    lockAp() { // 是否锁定应付费用
      return this.job && this.job.payableChargeLockedStatus === 1
    },
    showLockButton() {
      return this.viewSource !== 'BookingVerify' && this.viewSource !== 'RemoteBooking' && this.viewSource !== 'AeBookingVerify'
    },
    localAmountLabel() {
      return this.$t('FinanceManage.charge_equivalent') + this.localCurrency
    },
    showChargeSyncRecord() {
      return this.config.chargeSyncNeedConfirm && (((this.job.lob === 'SE' || this.job.lob === 'SI') && this.config.enableEntrustmentSI) ||
        ((this.job.lob === 'AE' || this.job.lob === 'AI') && this.config.consignationImportByAE) ||
        (this.job.lob === 'RE' || this.job.lob === 'RI') || this.job.lob === 'IE')
    },
    currentSettleBranchId() {
      return this.settleBranchId > 0 ? this.settleBranchId : ((this.config.currentOfficeCharge && this.job.salesOffice) ? this.job.salesOffice : this.$store.getters.currentOfficeId)
    },
    isOtherSettleBranchId() { // 是否其他结算公司
      return this.privilege.showOtherBranchCharge ? this.currentSettleBranchId !== this.$store.getters.currentOfficeId : false
    },
    settleBranchEnable() { // 修改其他结算公司费用
      return !this.isOtherSettleBranchId || (this.isOtherSettleBranchId && (this.privilege.modifyOtherBranchCharge || this.checkModifyOtherBranchCharge2ProfitShare))
    },
    checkModifyOtherBranchCharge2ProfitShare() {
      if (this.job && this.job.cooperateProfitShare !== -1) {
        return this.job.cooperateProfitShare === 1 && this.privilege.modifyOtherBranchCharge2ProfitShare
      }
      return false
    },
    checkShowAllCooperateCharge2ProfitShare() {
      if (this.job && this.job.cooperateProfitShare !== -1) {
        return this.job.cooperateProfitShare === 1 && this.privilege.showAllCooperateCharge2ProfitShare
      }
      return false
    },
    showEstimate() { // 是否显示预估
      // if (this.config.requireEstimate) {
      //   return !(this.config.isBookingFeeMandatoryAppliedGlobally && ![-1, 12].includes(this.job.jobState))
      // }
      // return false
      return this.config.requireEstimate
    },
    showWhtTax() {
      return this.$store.getters.currentOffice.whtTaxMode && ['RemoteBooking', 'BookingVerify', 'SeBooking', 'SiBooking', 'AeBooking', 'AiBooking', 'RailwayBooking', 'IeBooking', 'SiPrediction', 'AeBookingVerify', 'AiOrder', 'RailwayVerify', 'FinanceManage'].includes(this.viewSource)
    },
    isOperating() { // 业务状态是否等于正操作
      return this.job && this.job.jobState === 0
    },
    isBusinessModule() {
      // 海运订舱、海运操作、空运订舱、空运操作、铁路操作、综合物流操作
      return ['SeBooking', 'SiBooking', 'AeBooking', 'AiBooking', 'RailwayBooking', 'IeBooking'].includes(this.viewSource)
    },
    showUpdateDueDate() { // 显示修改费用到期日按钮
      return !this.editing && this.isBusinessModule && this.config.modificationFeeDueDate
    },
    isBusinessModuleList() {
      // 海运订舱、海运操作、空运订舱、空运操作、铁路操作、综合物流操作、FBA铁路头程、FBA海运头程、FBA空运头程
      return ['SeBooking', 'SiBooking', 'AeBooking', 'AiBooking', 'RailwayBooking', 'IeBooking'].includes(this.viewSource)
    },
    isBusinessFinanceManage() {
      // 财务审核
      return ['FinanceManage'].includes(this.viewSource)
    },
    cachePrefix() {
      if (this.type === 'ar') { // 应收
        return 'ar-'
      } else if (this.type === 'ap') { // 应付
        return 'ap-'
      } else {
        return ''
      }
    },
    showDown() {
      return (!this.type || this.type === 'ap') && (this.isBpm || this.tabSelling.visible)
    },
    showUp() {
      return (!this.type || this.type === 'ar') && (this.isBpm || this.tabCost.visible)
    },
    arPageType() {
      switch (this.job.lob) {
        case 'SE':
          return UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE
        case 'AE':
          return UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE
        default:
          return 0
      }
    },
    apPageType() {
      switch (this.job.lob) {
        case 'SE':
          return UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE
        case 'AE':
          return UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE
        default:
          return 0
      }
    },
    arElementDict() {
      switch (this.job.lob) {
        case 'SE':
          return this.seArElementDict
        case 'AE':
          return this.aeArElementDict
        default:
          return {}
      }
    },
    apElementDict() {
      switch (this.job.lob) {
        case 'SE':
          return this.seApElementDict
        case 'AE':
          return this.aeApElementDict
        default:
          return {}
      }
    }
  },
  watch: {
    addCostEventFlag(newVal) {
      if (newVal) {
        this.addCostEventFlag = false
        return catchErrorTip(() => {
          return this.tabChargesHP.addCost()
        })
      }
    },
    addSellingEventFlag(newVal) {
      if (newVal) {
        this.addSellingEventFlag = false
        return catchErrorTip(() => {
          return this.tabChargesHP.addSelling()
        })
      }
    },
    '$store.getters.currentOfficeId': {
      immediate: true,
      async handler() {
        await cache.load(cacheName.CONFIG)
        await ensureExecuteSuccess(() => this.job.lob)
        if (!this.job.lob) {
          return
        }
        const useParentCreditSetting = cache.config.get('useParentCreditSetting' + this.job.lob) === '1'
        const officeId = useParentCreditSetting ? 1 : this.$store.getters.currentOfficeId
        await getCreditConfig({ officeId, lob: this.job.lob }).then(res => {
          this.creditConfig = res.data
        })
        const provinceOfficeLevel = Number(cache.config.get('RegionalCommission'))
        const isRegionalCommission = provinceOfficeLevel >= 0 && this.$store.getters.currentOfficeLevel >= provinceOfficeLevel && this.$checkPermission(['roleGroup_Common_regionalCommission'])
        this.privilege.showOtherBranchCharge = isRegionalCommission ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['button_Charge_showOtherBranchCharge']))
        this.privilege.modifyOtherBranchCharge = isRegionalCommission ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['button_Charge_modifyOtherBranchCharge']))
        this.privilege.showAllCooperateCharge = isRegionalCommission ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['role_Charge_showAllCooperateCharge']))
        this.dataListDragGroup = Number(cache.config.get('DataListDragGroup')) === 1
        this.privilege.modifyOtherBranchCharge2ProfitShare = isRegionalCommission ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['button_Charge_modifyOtherBranchCharge2ProfitShare']))
        this.privilege.showAllCooperateCharge2ProfitShare = isRegionalCommission ? false : (RateUtil.useOrderCenterMode() && this.$checkPermission(['role_Charge_showAllCooperateCharge2ProfitShare']))
        if (this.$store.state.uiCustom.enable && this.enableUiCustom) {
          this.loadPageConfig()
        }
      }
    }
  },
  created() {
    this.once = new Once(this.tabChargesHP)
    this.tabChargesHP.created()
    this.tabCost.grid.gridOptions = {
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      singleClickEdit: true,
      rowSelection: 'multiple',
      // suppressCellSelection: true, refreshSellingSelected
      getRowStyle: (params) => {
        if (!params.data) {
          return {}
        }
        const chargeData = params.data
        const rowStyle = {}
        if (!this.tabChargesHP.isRowEdit(chargeData)) {
          Object.assign(rowStyle, { background: '#999999' })
        }
        if (Object.prototype.hasOwnProperty.call(chargeData, 'controlled') && chargeData.controlled) {
          Object.assign(rowStyle, { 'font-weight': 'bold', 'color': '#800000' })
        }
        return rowStyle
      },
      // 选中 勾选框或者其他列 都会触发
      onCellFocused: (event) => {
        this.onTabCostCellFocused(event)
      },
      onSelectionChanged: (event) => {
        // if (!event.data) {
        //   return
        // }
        this.filterChanage('tabCost')
        // keep the live AR selection count in sync for create-button disabled binding (P2-T5)
        this.arSelectedCount = this.tabCost.grid.gridApi ? this.tabCost.grid.gridApi.getSelectedRows().length : 0
      },
      // 选中 勾选框触发
      onRowSelected: (event) => {
        if (!event.data) {
          return
        }
        this.onTabCostRowSelected(event)
        // 根据选中行修改受控按钮权限
        this.tabChargesHP.dgOverseaCostChangeHandler(true)
      },
      onRowDragEnd: this.refreshSerialNumberForCost,
      frameworkComponents: {
        CargoAgGridAdvanceSelectEditor,
        CargoAgGridCommonInputEditor,
        CargoAgGridSelectEditor,
        CargoAgGridAdvanceMultipleSelectEditor,
        CargoAgGridCommonTextareaEditor
      }
    }
    this.arSumColumnDefs = this.tabChargesHP.getSumColumnDefsCost()
    this.tabSelling.grid.gridOptions = {
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      rowSelection: 'multiple',
      singleClickEdit: true,
      frameworkComponents: {
        CargoAgGridAdvanceSelectEditor,
        CargoAgGridCommonInputEditor,
        CargoAgGridSelectEditor,
        CargoAgGridAdvanceMultipleSelectEditor,
        CargoAgGridCommonTextareaEditor
      },
      // suppressCellSelection: true,
      getRowStyle: (params) => {
        if (!params.data) {
          return {}
        }
        const chargeData = params.data
        const rowStyle = {}
        if (!this.tabChargesHP.isRowEdit(chargeData)) {
          Object.assign(rowStyle, { background: '#999999' })
        }
        if (Object.prototype.hasOwnProperty.call(chargeData, 'controlled') && chargeData.controlled) {
          Object.assign(rowStyle, { 'font-weight': 'bold', 'color': '#800000' })
        }
        return rowStyle
      },
      onSelectionChanged: (event) => {
        // if (!event.data) {
        //   return
        // }
        this.filterChanage('tabSelling')
        // keep the live AP selection count in sync for create-button disabled binding (P2-T5)
        this.apSelectedCount = this.tabSelling.grid.gridApi ? this.tabSelling.grid.gridApi.getSelectedRows().length : 0
      },
      // 选中 勾选框或者其他列 都会触发
      onCellFocused: (event) => {
        this.onTabSellingCellFocused(event)
      },
      // 选中 勾选框触发
      onRowSelected: (event) => {
        if (!event.data) {
          return
        }
        this.onTabSellingRowSelected(event)
        // 根据选中行修改受控按钮权限
        this.tabChargesHP.dgOverseaSellingChangeHandler(false)
      },
      onRowDragEnd: this.refreshSerialNumberForSelling
    }
    this.tabSellingMerge.grid.gridOptions = {
      suppressRowClickSelection: true,
      suppressCopyRowsToClipboard: true,
      rowSelection: 'multiple',
      singleClickEdit: true,
      frameworkComponents: {
        CargoAgGridAdvanceSelectEditor,
        CargoAgGridCommonInputEditor,
        CargoAgGridSelectEditor,
        CargoAgGridAdvanceMultipleSelectEditor,
        CargoAgGridCommonTextareaEditor
      },
      getRowStyle: (params) => {
        if (!params.data) {
          return {}
        }
        const chargeData = params.data
        const rowStyle = {}
        if (!this.tabChargesHP.isRowEdit(chargeData)) {
          Object.assign(rowStyle, { background: '#999999' })
        }
        if (Object.prototype.hasOwnProperty.call(chargeData, 'controlled') && chargeData.controlled) {
          Object.assign(rowStyle, { 'font-weight': 'bold', 'color': '#800000' })
        }
        return rowStyle
      },
      onSelectionChanged: (event) => {
        // this.filterChanage('tabSellingMerge')
      },
      // 选中 勾选框或者其他列 都会触发
      onCellFocused: (event) => {
        // this.onTabSellingCellFocused(event)
      },
      // 选中 勾选框触发
      onRowSelected: (event) => {
        // if (!event.data) {
        //   return
        // }
        // this.onTabSellingRowSelected(event)
        // // 根据选中行修改受控按钮权限
        // this.tabChargesHP.dgOverseaSellingChangeHandler(false)
      }
      // onRowDragEnd: this.refreshSerialNumberForSelling
    }
    this.apSumColumnDefs = this.tabChargesHP.getSumColumnDefsSelling()
    this.setLocalCurrency()
  },
  async beforeMount() {
    await this.tabChargesHP.beforeMount()
  },
  methods: {
    loadPageConfig() {
      this.seArElementDict = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_CHARGE_RECEIVABLE, this.$store.getters.currentOfficeId).elementDict
      this.seApElementDict = UICustomUtil.getPageConfig(UICustomConstants.SEA_BOOKING_CHARGE_PAYABLE, this.$store.getters.currentOfficeId).elementDict
      this.aeArElementDict = UICustomUtil.getPageConfig(UICustomConstants.AIR_BOOKING_CHARGE_RECEIVABLE, this.$store.getters.currentOfficeId).elementDict
      this.aeApElementDict = UICustomUtil.getPageConfig(UICustomConstants.AIR_BOOKING_CHARGE_PAYABLE, this.$store.getters.currentOfficeId).elementDict
    },
    // 筛选后重新计算对应合计
    filterChanage(tableName) {
      if (tableName === 'tabCost') {
        const selections = this.tabChargesHP.getCostSelections()
        if (selections.length > 0) {
          this.once.excute(this.tabChargesHP.refreshCostSelected, [0, selections], 200)
        } else {
          this.$nextTick(() => {
            const hasDisplay = []
            this.tabCost.grid.gridOptions.api.forEachNode(node => {
              if (node.displayed) {
                hasDisplay.push(node.data)
              }
            })
            if (hasDisplay.length > 0) {
              if (hasDisplay.length === this.tabCost.grid.overseaCostDetails.length) {
                this.once.excute(this.tabChargesHP.refreshCostSelected, [], 200)
              }
              if (hasDisplay.length < this.tabCost.grid.overseaCostDetails.length) {
                this.once.excute(this.tabChargesHP.refreshCostSelected, [1, hasDisplay], 200)
              }
            } else {
              this.once.excute(this.tabChargesHP.refreshCostSelected, [1, hasDisplay], 200)
            }
          })
        }
      } else if (tableName === 'tabSelling') {
        const selections = this.tabChargesHP.getSellingSelections()
        if (selections.length > 0) {
          this.once.excute(this.tabChargesHP.refreshSellingSelected, [0, selections], 200)
        } else {
          this.$nextTick(() => {
            const hasDisplay = []
            this.tabSelling.grid.gridOptions.api.forEachNode(node => {
              if (node.displayed) {
                hasDisplay.push(node.data)
              }
            })
            if (hasDisplay.length > 0) {
              if (hasDisplay.length === this.tabSelling.grid.overseaSellingDetails.length) {
                this.once.excute(this.tabChargesHP.refreshSellingSelected, [], 200)
              }
              if (hasDisplay.length < this.tabSelling.grid.overseaSellingDetails.length) {
                this.once.excute(this.tabChargesHP.refreshSellingSelected, [1, hasDisplay], 200)
              }
            } else {
              this.once.excute(this.tabChargesHP.refreshSellingSelected, [1, hasDisplay], 200)
            }
          })
        }
      } else if (tableName === 'tabSellingMerge') {
        // const selections = this.tabChargesHP.getSellingMergeSelections()
        // if (selections.length > 0) {
        //   this.once.excute(this.tabChargesHP.refreshSellingSelected, [0, selections], 200)
        // } else {
        //   this.$nextTick(() => {
        //     const hasDisplay = []
        //     this.tabSelling.grid.gridOptions.api.forEachNode(node => {
        //       if (node.displayed) {
        //         hasDisplay.push(node.data)
        //       }
        //     })
        //     if (hasDisplay.length > 0) {
        //       if (hasDisplay.length === this.tabSelling.grid.overseaSellingDetails.length) {
        //         this.once.excute(this.tabChargesHP.refreshSellingSelected, [], 200)
        //       }
        //       if (hasDisplay.length < this.tabSelling.grid.overseaSellingDetails.length) {
        //         this.once.excute(this.tabChargesHP.refreshSellingSelected, [1, hasDisplay], 200)
        //       }
        //     } else {
        //       this.once.excute(this.tabChargesHP.refreshSellingSelected, [1, hasDisplay], 200)
        //     }
        //   })
        // }
      }
    },
    // 保存回调
    async getSubmitData() {
      // 生成唯一标识
      if (this.job.charges) {
        for (const charge of this.job.charges) {
          charge._id = charge._id || uuidv4()
        }
      }
      // console.log('getSubmitData============')
      const charges = []
      const chargeNumbers = []
      const delChargeUuids = [...this.tabCost.grid.deleteUuids, ...this.tabSelling.grid.deleteUuids]

      // 将单价为0的费用进行移除-CARGO-25284
      await this.tabChargesHP.validateUnitRate(delChargeUuids)
      // 移除单价和含税价为0的费用【放在刷新费用序号之前，避免序号问题】
      this.tabChargesHP.removeEmptyUnitRate([...this.tabCost.grid.overseaCostDetails, ...this.tabSelling.grid.overseaSellingDetails])
      if (this.isCostRowDragEnd) {
        this.doRefreshSerialNumberForCost()
      }
      const costCharges = lodash.cloneDeep(this.tabCost.grid.overseaCostDetails)
      if (this.$store.state.uiCustom.enable && this.enableUiCustom) {
        UICustomUtil.checkRowDataRequire(costCharges, this.arElementDict, this.tabName)
      }
      for (const charge of costCharges) {
        // 新增的费用
        if (charge.uuid.startsWith(this.tabCost.grid.uuidPrefixRule)) {
          charge.uuid = ''
        }
        // 修改的费用
        if (this.tabCost.grid.modifyUuids.includes(charge.uuid) || !charge.uuid) {
          charge.changer = this.$store.getters.userId
          charges.push(charge)
        } else {
          if (!charge.uuid) continue
          const chargeNumber = {}
          chargeNumber.uuid = charge.uuid
          chargeNumber.jobUuid = charge.jobUuid
          chargeNumber.serialNumber = charge.serialNumber
          chargeNumbers.push(chargeNumber)
        }
      }
      if (this.isSellingRowDragEnd) {
        this.doRefreshSerialNumberForSelling()
      }
      const sellingCharges = lodash.cloneDeep(this.tabSelling.grid.overseaSellingDetails)
      if (this.$store.state.uiCustom.enable && this.enableUiCustom) {
        UICustomUtil.checkRowDataRequire(sellingCharges, this.apElementDict, this.tabName)
      }
      for (const charge of sellingCharges) {
        // 新增的费用
        if (charge.uuid.startsWith(this.tabSelling.grid.uuidPrefixRule)) {
          charge.uuid = ''
        }
        // 修改的费用
        if (this.tabSelling.grid.modifyUuids.includes(charge.uuid) || !charge.uuid) {
          // 仓库内装 客户门点生成的 应付费用装箱费和 拖车费 已在各自页签提交数据保存了【此代码屏蔽，若切换过费用页签，则其他费用再费用页签保存，避免重复】
          // if (!charge.uuid && charge.hasOwnProperty('createdByOther') && charge.createdByOther) {
          //   continue
          // }
          charge.changer = this.$store.getters.userId
          charges.push(charge)
        } else {
          if (!charge.uuid) continue
          const chargeNumber = {}
          chargeNumber.uuid = charge.uuid
          chargeNumber.jobUuid = charge.jobUuid
          chargeNumber.serialNumber = charge.serialNumber
          chargeNumbers.push(chargeNumber)
        }
      }

      // CARGO-15169 修改业务的委托单位后，业务内委托单位关联的费用未能变更结算单位
      const modifiedCharges = this.tabChargesHP.removeChargeForModifiedData(null)
      if (modifiedCharges && modifiedCharges.length > 0) {
        for (const modifiedCharge of modifiedCharges) {
          if (modifiedCharge.uuid) {
            if (modifiedCharge.uuid.startsWith('addTabSelling__') || modifiedCharge.uuid.startsWith('addTabCost__')) {
              modifiedCharge.uuid = ''
            }
          }
          if (!charges.includes(modifiedCharge)) {
            modifiedCharge.changer = this.$store.getters.userId
            charges.push(modifiedCharge)
          }
        }
      }
      // console.log('费用页签-chargeNumbers', chargeNumbers)
      for (const charge of charges) {
        if (this.job.businessDate && this.job.lob === 'AI') {
          charge.businessDate = this.job.businessDate
        }
      }
      // 费用保存校验
      this.tabChargesHP.validateForm(charges)
      // CARGO-32766 1855：预估费用可在提交【订舱预审】-【待审核、已拒绝】时，进行同步【非正式业务的时候进行同步】
      const isSyncEstimate = (this.job.lob === 'SE' && (this.job.jobState === -1 || this.job.jobState === 12))
      await this.tabChargesHP.refreshEstimateProfit(isSyncEstimate)
      // 如果是fba业务走这里【FBA下单，订单审核】
      if (this.job.fba && (this.viewSource === 'fbaOrder' || this.viewSource === 'fbaVerify')) {
        if (this.job._data.tabCostApi) {
          this.job._data.tabCostApi = undefined
        }
        const form = { ...this.job._data }
        form.charges = charges
        form.chargeNumbers = chargeNumbers
        form.delChargeUuids = delChargeUuids
        return form
      }
      // this.job 是class 类型
      const job = { ...this.job._data }
      return {
        job: job, // 目前用到 运价表 运价单号保存
        charges,
        chargeNumbers, // 费用序号保存使用【只处理数据库已存在的数据】 新增的数据，以及修改过除序号以外字段的数据不在此列，应在上面【charges】修改实体或新增实体实现
        delChargeUuids
      }
    },
    onTabSellingRowSelected(event) {
      if (event.node.isSelected()) {
        this.tabSelling.grid.selectedRow = event.data
        this.tabSelling.grid.chooseUuidSet.delete(event.data.uuid)
      }
    },
    onTabSellingCellFocused(event) {
      // console.log('onCellFocused', event)
      if (this.tabSelling.grid.gridApi && event.column) {
        this.tabSelling.grid.gridApi.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            if (event.data) {
              this.tabSelling.grid.selectedRow = node.data
            }
            this.tabSelling.grid.groupRowNode = node
            // console.log('selectedRow============')
          }
        })
      }
    },
    onTabCostRowSelected(event) {
      // console.log('onTabCostRowSelected start', event)
      if (event.node.isSelected()) {
        this.tabCost.grid.selectedRow = event.node.data
        this.tabCost.grid.chooseUuidSet.delete(event.data.uuid)
      }
    },
    onTabCostCellFocused(event) {
      // console.log('onCellFocused', event)
      if (this.tabCost.grid.gridApi && event.column) {
        this.tabCost.grid.gridApi.forEachNode(node => {
          if (node.rowIndex === event.rowIndex) {
            if (event.data) {
              this.tabCost.grid.selectedRow = node.data
            }
            this.tabCost.grid.groupRowNode = node
            // console.log('selectedRow============')
          }
        })
      }
    },
    toResetTabCostSelected() {
      this.tabCost.grid.gridApi.forEachNode(node => {
        // console.log('this.tabCost.grid.chooseUuidSet.has(node.data.uuid)', this.tabCost.grid.chooseUuidSet.has(node.data.uuid))
        node.selectThisNode(this.tabCost.grid.chooseUuidSet.has(node.data.uuid))
      })
    },
    hasEnabledConfig(configName) {

    },
    onCostGridReady(params) {
      this.tabCost.grid.gridApi = params.api
      this.tabChargesHP.refreshSalePriceHcColumnVisibility()
    },
    onSellingGridReady(params) {
      this.tabSelling.grid.gridApi = params.api
      this.tabChargesHP.refreshSalePriceHcColumnVisibility()
    },
    onSellingMergeGridReady(params) {
      this.tabSellingMerge.grid.gridApi = params.api
      this.tabChargesHP.refreshSalePriceHcColumnVisibility()
    },
    initState() { // 重置一些属性or状态
      // this.tabCost.grid.overseaCostDetails = []
      // this.tabSelling.grid.overseaSellingDetails = []
      this.tabSelling.grid.selectedRow = null
      this.tabCost.grid.selectedRow = null
      this.arChargeSyncEnabled = false
    },
    getAllContainerNoHandler() {
      if (this.job.containers) {
        this.currentViewCacheData.containerNoAllSet = new Set()
        for (const c of this.job.containers) {
          if (c.containerNo) {
            const cData = {}
            cData['containerNo'] = c.containerNo
            this.currentViewCacheData.containerNoAllSet.add(cData)
          }
        }
      }
    },
    async onShow(row, isRefresh) {
      console.log('=进入费用页签的row', row)
      this.getAllContainerNoHandler()
      this.isCostRowDragEnd = false
      this.isSellingRowDragEnd = false
      this.setListOldSort()
      this.receiptCharges = row.receiptCharges
      // reloadCharge拆成应收、应付两个标识
      if (this.type === 'ar' || this.type === 'ap') {
        if (this.context.reloadCharge) {
          this.context.reloadChargeAr = true
          this.context.reloadChargeAp = true
          this.context.reloadCharge = false
        }
      }
      // reloadCharge应收标识处理
      if (this.type === 'ar') {
        if (!this.matchCharges(this.job.charges, this.tabCost.grid.overseaCostDetails, true) || !this.matchCharges(this.job.charges, this.tabSelling.grid.overseaSellingDetails, false)) {
          this.context.reloadChargeAr = true
        }
        if (!isRefresh && !this.context.reloadChargeAr) {
          this.refreshChargeCurrencyTotal()
          return
        }
        this.context.reloadChargeAr = false
      } else if (this.type === 'ap') { // reloadCharge应付标识处理
        if (!this.matchCharges(this.job.charges, this.tabCost.grid.overseaCostDetails, true) || !this.matchCharges(this.job.charges, this.tabSelling.grid.overseaSellingDetails, false)) {
          this.context.reloadChargeAp = true
        }
        if (!isRefresh && !this.context.reloadChargeAp) {
          this.refreshChargeCurrencyTotal()
          return
        }
        this.context.reloadChargeAp = false
      } else { // reloadCharge标识处理
        if (!isRefresh && !this.context.reloadCharge) {
          return
        }
        this.context.reloadCharge = false
      }
      this.job = JobUtils.getJobByType(row)
      if (row.cooperatebranch) this.job.cooperatebranch = row.cooperatebranch // 协作分公司
      if (row.opOffice_original) this.job.opOffice_original = row.opOffice_original
      this.initState()
      if ((this.editing && !this.isOtherEdit && isRefresh && (!this.job.charges || this.job.charges.length <= 0)) || !this.editing) { // 详情从数据库中加载数据
        this.job.charges = ''
      }
      if (isRefresh && this.editing) {
        this.tabCost.grid.deleteUuids = []
        this.tabSelling.grid.deleteUuids = []
      }
      if (row.fba) {
        row.tabCostApi = this.tabCost.grid.gridApi
      }
      this.config.arSettlementUnitOptional = parseInt(cache.config.get('ArSettlementUnitOptional')) === 1
      // 开启合作伙伴工厂，应收费用使用关联工厂
      this.companyFactorySigns = []
      if (this.config.arSettlementUnitOptional) {
        this.companyFactorySigns = await ChargeUtils.getCompanyFactorySign(this.job.customerId)
      }
      try {
        // this.$logger.log('job.charges 3', this.job.charges)
        // 记录一个标识，在结果返回后，如果标识不一致，则中断操作（避免上一票费用覆盖当前票）
        const mark = this.markManage.regenerateMark('onShow')
        // 销售角色可选结算对象范围外的显示星号
        this.config.accountObjectControlMode = Number(cache.config.get('AccountObjectControlMode')) === 1
        if (this.customerSalesDisplay && this.config.accountObjectControlMode && !this.$store.getters.isAdmin && (this.$checkPermission(['role_SalesQueryModule_salesCustomer']) || this.$checkPermission(['role_SalesQueryModule_departmentCustomer']))) {
          getCustomerByRole({ branch: this.$store.getters.currentOfficeId }).then(res => {
            this.customerSalesCmpList = getFilterCacheList(TYPE_NAMES.basic_data_Company, p => res.data.includes(p.cmpIdx))
          })
        }
        const chargeDetails = await Job.getChargeDetails(this.job)
        if (this.markManage.readMark('onShow') !== mark) {
          return
        }
        // 初始化费用更正状态
        if (chargeDetails) {
          this.chargeChangeStateMap = chargeDetails.chargeChangeStateMap
          // CARGO-31783 费用页签新增【结算类型】显示列
          this.creditInfoVOMap = chargeDetails.creditInfoVOMap
          if (chargeDetails.charges && chargeDetails.charges.length > 0) {
            for (const charge of chargeDetails.charges) {
              const creditInfo = this.creditInfoVOMap[charge.accountId]
              if (creditInfo) {
                charge.settlementType = creditInfo.creditDateLimited > 0
              }
            }
          }
        }
        if (!this.isOtherEdit) {
          this.job.charges = chargeDetails.charges
        }
        this.initHasProfitShare()
        // 结算公司
        if (this.privilege.showOtherBranchCharge) {
          this.refreshCooperatebranch(row.cooperatebranch || '')
        } else {
          // CARGO-32760 使用接单中心协同操作后，防止没有权限，操作公司的操作可以看到其他结算公司的费用
          this.settleBranchId = this.$store.getters.currentOfficeId
        }
        // this.$logger.log('job.charges 4', this.job.charges)
        // 会调用 sortCharges 费用排序
        await this.tabChargesHP.creationCompleteHandler(chargeDetails)
      } finally {
        this.recordSortByList()
      }
      this.updateReceiptsRate()
      if (this.$store.state.uiCustom.enable && this.enableUiCustom) {
        UICustomUtil.handleViewAndWrite(this.arPageType, this.arElementDict, row)
        UICustomUtil.handleViewAndWrite(this.apPageType, this.apElementDict, row)
      }
    },
    matchCharges(sourceCharges, targetCharges, receivable) {
      if (!sourceCharges || !targetCharges) {
        return false
      }
      const sourceChargeSet = new Set()
      for (const item of sourceCharges) {
        if (item.receivable === receivable) {
          sourceChargeSet.add(item)
        }
      }
      for (const item of targetCharges) {
        if (item.receivable === receivable) {
          if (sourceChargeSet.has(item)) {
            sourceChargeSet.delete(item)
          } else {
            return false
          }
        }
      }
      return sourceChargeSet.size === 0
    },
    refreshChargeCurrencyTotal() {
      const arList = this.tabChargesHP.getArTotalCharges(this.tabCost.grid.overseaCostDetails)
      const apList = this.tabChargesHP.getApTotalCharges(this.tabSelling.grid.overseaSellingDetails)
      this.arAuxiliaryDataMap = this.tabChargesHP.getCurrencyTotalMap(arList)
      this.apAuxiliaryDataMap = this.tabChargesHP.getCurrencyTotalMap(apList)
      this.arTotalGroup.dataProvider = arList
      this.apTotalGroup.dataProvider = apList
      this.revenueTotalGroup.dataProvider = this.privilege.showControlledProfit ? this.jobControlledCharges : this.tabChargesHP.getTotalCharges()
      this.revenueTotalGroup.dataProvider = [...this.revenueTotalGroup.dataProvider]
      // 刷新预估利润
      this.$nextTick(() => {
        this.tabChargesHP.refreshEstimateProfit()
      })
      this.reCalc = false
      this.$nextTick(() => {
        this.reCalc = true
      })
    },
    updateReceiptsRate() {
      if (this.receiptCharges && this.receiptCharges.length > 0) {
        for (const charge of this.receiptCharges) {
          if (typeof this.tabCost.grid.overseaCostDetails !== 'undefined' && typeof this.tabCost.grid.overseaCostDetails[Symbol.iterator] === 'function') {
            for (const ys of this.tabCost.grid.overseaCostDetails) {
              if (ys.uuid === charge.uuid) {
                console.log('更改费用汇率为', charge.exchangeRate)
                ys.exchangeRate = charge.exchangeRate
              }
            }
          }
          if (typeof this.tabSelling.grid.overseaSellingDetails !== 'undefined' && typeof this.tabSelling.grid.overseaSellingDetails[Symbol.iterator] === 'function') {
            for (const yf of this.tabSelling.grid.overseaSellingDetails) {
              if (yf.uuid === charge.uuid) {
                yf.exchangeRate = charge.exchangeRate
              }
            }
          }
        }
      }
    },
    copySlaveCostSuccessHandler(charges) {
      if (charges) {
        for (const charge of charges) {
          this.job.charges.push(charge)
        }
      }
      this.tabChargesHP.loadForBookingResultHandler()
    },
    onFCLSelected(data) {
      this.tabChargesHP.onFCLSelected(data)
    },
    onLCLSelected(data) {
      this.tabChargesHP.onLCLSelected(data)
    },
    // 应收刷新序号【拖拽/保存前使用】
    refreshSerialNumberForCost(e) {
      this.isCostRowDragEnd = true
      this.doRefreshSerialNumberForCost()
    },
    doRefreshSerialNumberForCost() {
      if (this.tabCost.grid.gridApi) {
        this.tabCost.grid.gridApi.forEachNode(node => {
          const charge = node.data
          if (charge) {
            charge.serialNumber = node.rowIndex + 1
          }
        })
        this.tabCost.grid.gridApi.refreshCells({ force: true }) // 刷新
      }
      // console.log('费用页签-refreshSerialNumberForCost', this.tabCost.grid.overseaCostDetails)
    },
    // 应付刷新序号【拖拽/保存前使用】
    refreshSerialNumberForSelling(e) {
      this.isSellingRowDragEnd = true
      this.doRefreshSerialNumberForSelling()
    },
    doRefreshSerialNumberForSelling() {
      if (this.tabSelling.grid.gridApi) {
        this.tabSelling.grid.gridApi.forEachNode(node => {
          const charge = node.data
          if (charge) {
            charge.serialNumber = node.rowIndex + 1
          }
        })
        this.tabSelling.grid.gridApi.refreshCells({ force: true }) // 刷新
      }
    },
    // 组装打印参数
    async getPrintData() {
      let rows = []
      const overseaCostDetails = this.tabCost.grid.overseaCostDetails
      const sellDetails = this.tabSelling.grid.overseaSellingDetails
      if (overseaCostDetails && overseaCostDetails.length > 0) {
        rows = rows.concat(overseaCostDetails)
      }
      if (sellDetails && sellDetails.length > 0) {
        rows = rows.concat(sellDetails)
      }
      if (!rows || rows.length <= 0) {
        this.$message.warning(this.$t('Message.ChargeEmpty'))
        return
      }
      const accounts = await this.tabChargesHP.getChargeAccounts(rows)
      if (accounts.length > 1) {
        this.settlementSelectDialog.title = this.$t('Message.SelectTheBillingObject')
        this.settlementSelectDialog.accounts = accounts
        this.settlementSelectDialog.type = 'print'
        this.settlementSelectDialog.visible = true
      } else {
        if (accounts.length === 0) {
          this.$message.warning(this.$t('Message.NoChargeForTheSettlementOfPrint'))
          return
        }
        await this.printChargeBilling(accounts[0].cmpIdx)
      }
      return null
    },
    selectItemWinHandler(accountId) {
      if (this.settlementSelectDialog.type === 'eas') { // 同步费用使用
        this.tabChargesHP.confirmSyncChargeToEas(accountId)
        this.settlementSelectDialog.type = ''
        return
      }
      this.printChargeBilling(accountId)
    },
    async printChargeBilling(accountId) {
      if (!accountId || parseInt(accountId) <= 0) return
      const params = {}
      params.accountId = accountId
      params.ACCOUNT_ID = accountId
      if (this.job) {
        params.jobuuid = this.job.uuid
        params.JOB_UUID = this.job.uuid
        if (this.job.lob === 'SE') {
          const docs = await new SeaExportJob(this.job).getSeaCargoDoc()
          if (docs && docs.length > 0) {
            for (const doc of docs) {
              if (doc.uuid && doc.docType === 'HBL2' && doc.chargePrint) {
                params.CARGODOC_UUID = doc.uuid
                break
              }
            }
          }
        } else {
          params.CARGODOC_UUID = ''
        }
        params.CHARGE_LIST = this.tabChargesHP.getAllSelectedRows(false)
      }
      params.category = 'JOB_CHARGE'
      this.templateSelectorDialog.ctx = JobUtils.getJobByType(this.job)
      this.templateSelectorDialog.category = params.category
      this.templateSelectorDialog.data = params
      this.templateSelectorDialog.visible = true
      // TemplateSelectorWin.getInstance().showThisWin(job, "JOB_CHARGE", params, this);
    },
    /**
     * 修改预估
     */
    editEstimateHandler() {
      const job = this.job
      if (this.editing && (!job.estimateAccountsReceivable || job.estimateAccountsReceivable === 0 || !job.uuid)) {
        this.estimateValidationDialog.job = job
        this.estimateValidationDialog.editable = true
        this.estimateValidationDialog.visible = true
      }
    },
    getInvoiceTitleList(accountId) {
      if (this.currentViewCacheData.customerTitlesMap.get(accountId)) {
        return this.currentViewCacheData.customerTitlesMap.get(accountId).reduce((res, item) => {
          if (!res.find(re => re.invoiceTitle === item.invoiceTitle && re.taxAccount === item.taxAccount)) {
            res.push(item)
          }
          return res
        }, [])
      }
      return []
    },
    getSettlementAgentList(accountId) {
      if (this.currentViewCacheData.customerSettlementAgentMap && this.currentViewCacheData.customerSettlementAgentMap.get(accountId)) {
        return this.currentViewCacheData.customerSettlementAgentMap.get(accountId)
      }
      return []
    },
    setLocalCurrency() {
      this.localCurrency = RateUtil.localCurrencyByOffice()
      if (this.localCurrency !== 'RMB') {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    },
    /**
     * 将之前的排序还原
     */
    setListOldSort() {
      if (!this.editing) {
        if (this.tabCost.grid.gridApi) {
          if (this.oldCostSort) {
            this.$refs.tabCostGrid.setListSort(this.tabCost.grid.gridOptions, this.oldCostSort)
          }
          this.tabCost.grid.gridOptions.api.refreshCells({ force: true }) // 刷新
        }
        if (this.tabSelling.grid.gridApi) {
          if (this.oldSellingSort) {
            this.$refs.tabSellingGrid.setListSort(this.tabSelling.grid.gridOptions, this.oldSellingSort)
          }
          this.tabSelling.grid.gridOptions.api.refreshCells({ force: true }) // 刷新
        }
        if (this.showMergeChargeItemSalesView && this.tabSellingMerge.grid.gridApi) {
          if (this.oldSellingMergeSort) {
            this.$refs.tabSellingGridMerge.setListSort(this.tabSellingMerge.grid.gridOptions, this.oldSellingMergeSort)
          }
          this.tabSellingMerge.grid.gridOptions.api.refreshCells({ force: true }) // 刷新
        }
      }
    },
    /**
     * 取消列表排序，然后根据规则排序
     */
    recordSortByList() {
      if (this.editing) {
        setTimeout(() => {
          if (this.tabCost.grid.gridApi) {
            // 取消列表排序 返回排序规则
            this.oldCostSort = this.$refs.tabCostGrid.resetSort2(this.tabCost.grid.gridOptions)
            if (this.oldCostSort) {
              // 根据排序规则 手动排序
              this.tabChargesHP.sortCharges2(this.tabCost.grid.overseaCostDetails, this.oldCostSort)
              this.tabCost.grid.gridOptions.api.refreshCells({ force: true }) // 刷新
            }
          }
          if (this.tabSelling.grid.gridApi) {
            // 取消列表排序 返回排序规则
            this.oldSellingSort = this.$refs.tabSellingGrid.resetSort2(this.tabSelling.grid.gridOptions)
            if (this.oldSellingSort) {
              // 根据排序规则 手动排序
              this.tabChargesHP.sortCharges2(this.tabSelling.grid.overseaSellingDetails, this.oldSellingSort)
              this.tabSelling.grid.gridOptions.api.refreshCells({ force: true }) // 刷新
            }
          }
          if (this.showMergeChargeItemSalesView && this.tabSellingMerge.grid.gridApi) {
            // 取消列表排序 返回排序规则
            this.oldSellingMergeSort = this.$refs.tabSellingGridMerge.resetSort2(this.tabSellingMerge.grid.gridOptions)
            if (this.oldSellingMergeSort) {
              // 根据排序规则 手动排序
              this.tabChargesHP.sortCharges2(this.tabSellingMerge.grid.overseaSellingDetails, this.oldSellingMergeSort)
              this.tabSellingMerge.grid.gridOptions.api.refreshCells({ force: true }) // 刷新
            }
          }
        }, 200)
      }
    },
    chargeSyncConfirmCallback(refreshCharge) {
      this.tabChargesHP.queryPendingChargeSyncRecountNum()
      if (refreshCharge) {
        this.onShow(this.job, true)
      }
    },
    chargeOutSyncConfirmCallback(refreshCharge) {
      this.tabChargesHP.queryPendingChargeOutSyncRecountNum()
      if (refreshCharge) {
        this.onShow(this.job, true)
      }
    },
    async refreshCooperatebranch(cooperatebranch) {
      const officeAll = getCacheListByKey(basicCacheKeys.basic_data_Office_All)
      let officeList = []
      if (cooperatebranch) {
        if (this.privilege.showAllCooperateCharge || this.checkShowAllCooperateCharge2ProfitShare) officeList.push({ code: 'ALL', chineseName: 'ALL', officeId: 0 })
        if (this.hasProfitShare && !(this.privilege.showAllCooperateCharge || this.checkShowAllCooperateCharge2ProfitShare)) {
          officeList = officeAll.filter(p => p.code !== 'HQ' && p.officeId === this.job.opOffice)
        } else {
          const list = cooperatebranch.split(' | ')
          if (list && list.length > 0) {
            for (const officeName of list) {
              for (const office of officeAll) {
                if (officeList.indexOf(office) === -1 && (officeName === office.chineseName ||
                office.officeId === this.job.opOffice || office.officeId === this.job.opOffice_original)) {
                  officeList.push(office)
                }
              }
            }
          }
        }
      } else {
        // BJCJ-502，优化 结算分公司按钮
        officeList = officeAll.filter(p => p.code !== 'HQ' && (p.officeId === this.job.opOffice || p.officeId === this.job.opOffice_original))
      }
      // CARGO-34770 销售人员在业务中选择其他公司时，新增的费用的结算公司要属于系统右上角当前分公司
      if (this.config.currentOfficeCharge && this.job.salesOffice && officeList) {
        let haveSalesOffice = false
        for (const item of officeList) {
          if (item.officeId === this.job.salesOffice) {
            haveSalesOffice = true
            break
          }
        }
        if (!haveSalesOffice) {
          const office = getObjectByCache(basicCacheKeys.basic_data_Office_All, 'officeId', this.job.salesOffice)
          if (office) this.officeList.push(office)
        }
      }
      this.officeList = officeList.sort((office1, office2) => office1.officeId > office2.officeId ? 1 : -1)
      let settleBranchStr = sessionStorage.getItem(this.cachePrefix + 'settleBranchId.' + this.job.uuid)
      if (this.officeList.length > 0 && settleBranchStr && this.officeList.filter(p => p.officeId === parseInt(settleBranchStr)).length === 0) {
        settleBranchStr = ''
      }
      this.settleBranchId = settleBranchStr ? parseInt(settleBranchStr) : this.tabChargesHP.getBranchIdForCharge()
    },
    async getGpExplainRecordByJobUuid() {
      // 如果jobNo为空不处理
      if (this.job && this.job.uuid) {
        // 调用接口保存
        const resp = await queryGpExplainRecord({ 'jobUuid': this.job.uuid })
        if (resp.ok) {
          if (resp.data && resp.data.length > 0) {
            let str = ''
            for (const item of resp.data) {
              // 获取GP说明标题
              const gpExplainTitle = getObjectByCache(TYPE_NAMES.basic_data_GpExplainTitle, 'code', item.code)
              if (!gpExplainTitle) {
                continue
              }
              const gpExplainTitleName = this.language ? gpExplainTitle.chineseName : gpExplainTitle.englishName
              // 获取用户信息
              const user = getObjectByCache(TYPE_NAMES.basic_data_User, 'userId', item.createdBy)
              let userName = ''
              if (user) {
                userName = this.language ? user.chineseName : user.englishName
              }
              str = str + gpExplainTitleName + ':  ' + item.remark + '(' + userName + '  ' + item.dateCreated + ')' + '\n'
            }
            if (str) {
              this.gpExplain.gpExplainContent = str
            }
          } else {
            this.gpExplain.gpExplainContent = ''
          }
        }
      }
    },
    // 是否参与分润费用
    initHasProfitShare() {
      this.hasProfitShare = false
      if (this.job && this.job.charges) {
        for (const item of this.job.charges) {
          if (item.profitShare || item.chargeSource === SystemConstants.CHARGE_SOURCE_PROFIT_SHARE.code) {
            this.hasProfitShare = true
            return
          }
        }
      }
    }
  }
}
</script>

<style lang="scss">
.tab-charges {
  padding: 10px;

  .up {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 200px;
  }

  .triggers {}

  .filters {
    display: flex;
    flex-direction: column;
  }

  .ag-header-cell-left {
    .ag-header-cell-label {
      justify-content: left;
    }
  }
  .ag-header-cell-center {
    .ag-header-cell-label {
      justify-content: center;
    }
  }
  .ag-header-cell-right {
    .ag-header-cell-label {
      justify-content: flex-end;
    }
  }
  .gp-explain{
    display: flex;
    margin-left: 10px;

    .gp-explain-click {
      width: 70px;
      color:#0F10F5;
    }

    .gp-explain-ellipsis {
      flex: 1;
      white-space: nowrap; /* 保持文本在一行显示 */
      overflow: hidden; /* 隐藏超出部分的文本 */
      text-overflow: ellipsis; /* 在文本末尾添加省略号 */
      max-width: 100%; /* 确保文本不会溢出其容器 */
      width: 350px;
      //margin-left: 15px
    }
  }

}
</style>
